import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import axios from "axios";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const FuelOptions = [
  { value: "PETROL", label: "Petrol" },
  { value: "DIESEL", label: "Diesel" },
  { value: "CNG", label: "CNG" },
  { value: "LPG", label: "LPG" },
  { value: "CNG/PETROL", label: "CNG / Petrol" },
  { value: "CNG/Diesel", label: "CNG / Diesel" },
  { value: "ELECTRIC", label: "Electric" },
];
const BookingDocketDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const allowAlphaNumeric = (value) => value.replace(/[^a-zA-Z0-9]/g, "");
  const [EnquirynoList, setEnquirynoList] = useState([]);
  const [Enquiryno, setEnquiryno] = useState("");
  const [DocketNo, setDocketNo] = useState("");
  const [docketDate, setDocketDate] = useState("");
  const [Dockettype, setDockettype] = useState("");
  const [BranchList, setBranchList] = useState([]);
  const [Branch, setBranch] = useState("");
  const [Salutation, setSalutation] = useState("");
  const [Name, setName] = useState("");
  const [PrintName, setPrintName] = useState("");
  const [FatherName, setFatherName] = useState("");
  const [Address, setAddress] = useState("");
  const [Email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState(false);
  const [StateList, setStateList] = useState([]);
  const [State, setState] = useState("");
  const [CityList, setCityList] = useState([]);
  const [City, setCity] = useState("");
  const [AreaList, setAreaList] = useState([]);
  const [Area, setArea] = useState("");
  const [showCityModal, setShowCityModal] = useState(false);
  const [newCityName, setNewCityName] = useState("");
  const [newCityStateName, setNewCityStateName] = useState("");
  const [showAreaModal, setShowAreaModal] = useState(false);
  const [newAreaName, setNewAreaName] = useState("");
  const [newZipCode, setNewZipCode] = useState("");
  const [newAreaCityName, setNewAreaCityName] = useState("");
  const [Zipcode, setZipcode] = useState("");
  const [MobileNo, setMobileNo] = useState("");
  const [MobileError, setMobileError] = useState(false);
  const [ContactNo, setContactNo] = useState("");
  const [BirthDate, setBirthDate] = useState("");
  const [AnniversaryDate, setAnniversaryDate] = useState("");
  const [NomineeName, setNomineeName] = useState("");
  const [PanCard, setPanCard] = useState("");
  const [GSTIN, setGSTIN] = useState("");
  const [BookingDMSId, setBookingDMSId] = useState("");
  const [imageUpload, setImageUpload] = useState(null);
  const [filePath1, setFilePath1] = useState("");
  const [aadharFrontUpload, setAadharFrontUpload] = useState(null);
  const [aadharFrontPreview, setAadharFrontPreview] = useState("");
  const [aadharBackUpload, setAadharBackUpload] = useState(null);
  const [aadharBackPreview, setAadharBackPreview] = useState("");
  const [panFrontUpload, setPanFrontUpload] = useState(null);
  const [panFrontPreview, setPanFrontPreview] = useState("");
  const [gstPdfUpload, setGstPdfUpload] = useState(null);
  const [gstPdfName, setGstPdfName] = useState("");
  const [commitmentUpload, setCommitmentUpload] = useState(null);
  const [commitmentFileName, setCommitmentFileName] = useState("");
  const [aadhaarFrontPath, setAadhaarFrontPath] = useState("");
  const [aadhaarBackPath, setAadhaarBackPath] = useState("");
  const [panPath, setPanPath] = useState("");
  const [gstPath, setGstPath] = useState("");
  const [commitmentPath, setCommitmentPath] = useState("");
  const [NomineeAge, setNomineeAge] = useState("");
  const [NomineeRelation, setNomineeRelation] = useState("");
  const [NomineeMobile, setNomineeMobile] = useState("");
  const [NomineeMobileError, setNomineeMobileError] = useState(false);
  const [Aadhaar, setAadhaar] = useState("");
  const [AadhaarError, setAadhaarError] = useState(false);
  const [saleConsultantList, setSaleConsultantList] = useState([]);
  const [saleConsultant, setSaleConsultant] = useState("");
  const [teamLeader, setTeamLeader] = useState("");
  const [manager, setManager] = useState("");
  const [fuel, setFuel] = useState("");
  const [fuelList] = useState(FuelOptions);
  const [modelList, setModelList] = useState([]);
  const [model, setModel] = useState("");
  const [variantList, setVariantList] = useState([]);
  const [variant, setVariant] = useState("");
  const [colorList, setColorList] = useState([]);
  const [color, setColor] = useState("");
  const [manufacturingYear, setManufacturingYear] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [sourceBookingList, setSourceBookingList] = useState([]);
  const [sourceBooking, setSourceBooking] = useState("");
  const [specificCode, setSpecificCode] = useState("");
  const [financeType, setFinanceType] = useState("");
  const [companyAuthorised, setCompanyAuthorised] = useState("");
  const [hpnList, setHpnList] = useState([]);
  const [hpn, setHpn] = useState("");
  const [hpnBranchList, setHpnBranchList] = useState([]);
  const [hpnBranch, setHpnBranch] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [netDisbursedAmount, setNetDisbursedAmount] = useState("");
  const [schemeTypeList, setSchemeTypeList] = useState([]);
  const [schemeType, setSchemeType] = useState("");
  const [schemeNameList, setSchemeNameList] = useState([]);
  const [schemeName, setSchemeName] = useState("");
  const [schemeAmount, setSchemeAmount] = useState("");
  const [schemeGrid, setSchemeGrid] = useState([]);
  const [specialDiscount, setSpecialDiscount] = useState("");
  const [exShowroom, setExShowroom] = useState(0);
  const [vehicleCess, setVehicleCess] = useState(0);
  const [vehicleCC, setVehicleCC] = useState(0);
  const [schemesLess, setSchemesLess] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [tcs, setTcs] = useState(0);
  const [priceProtection, setPriceProtection] = useState(false);
  const [packagePrice, setPackagePrice] = useState(0);
  const [spCode, setSpCode] = useState("");
  // ================= INSURANCE ADDONS =================
  // ===== STEP 3 MAIN INSURANCE VALUES =====
  const [insuranceType, setInsuranceType] = useState("InHouse");
  const [insurancecompanyList, setinsurancecompanyList] = useState([]);
  // ================= INSURANCE =================
  const [insurancecompany, setinsurancecompany] = useState("");
  const [insuranceAmount, setInsuranceAmount] = useState(0);
  const [insuranceMaster, setInsuranceMaster] = useState({});
  const [insuranceCalc, setInsuranceCalc] = useState({});
  const [showInsurancePopup, setShowInsurancePopup] = useState(false);
  const [insuranceRemarks, setInsuranceRemarks] = useState("");
  const [addEP, setAddEP] = useState(false);
  const [addRTI, setAddRTI] = useState(false);
  const [addCM, setAddCM] = useState(false);
  const [addPB, setAddPB] = useState(false);
  const [addKP, setAddKP] = useState(false);
  const [addZD, setAddZD] = useState(false);
  const [scrappage, setScrappage] = useState(0);
  const [addNilDep, setAddNilDep] = useState(false);
  const [addRSA, setAddRSA] = useState(false);
  const [addEmiCover, setAddEmiCover] = useState(false);
  const [addLossIncome, setAddLossIncome] = useState(false);
  const [addConsumables, setAddConsumables] = useState(false);
  const [addTowing, setAddTowing] = useState(false);

  const [addEmergency, setAddEmergency] = useState(false);
  const [addDailyAllowance, setAddDailyAllowance] = useState(false);
  const [addTyreCover, setAddTyreCover] = useState(false);
  const [addChargerProtection, setAddChargerProtection] = useState(false);
  const [addBatteryCover, setAddBatteryCover] = useState(false);
  const [zipAutoLoaded, setZipAutoLoaded] = useState(false);
  // ================= RTO =================
  const [rtoType, setRtoType] = useState("InHouse");
  const [rtoExShowroom, setRtoExShowroom] = useState(0);
  const [rtoTemporary, setRtoTemporary] = useState(0);
  const [rtoAmount, setRtoAmount] = useState(0);
  const [municipalTax, setMunicipalTax] = useState(false);
  const [municipalAmount, setMunicipalAmount] = useState(0);
  const [showRtoPopup, setShowRtoPopup] = useState(false);
  const [vehicleOwnStatus, setVehicleOwnStatus] = useState("one");
  // ================= TRC =================
  const [trcType, setTrcType] = useState("InHouse");
  const [trcAmount, setTrcAmount] = useState(0);
  const [trcSpecificNo, setTrcSpecificNo] = useState("");
  const [trcSpecificAmount, setTrcSpecificAmount] = useState(0);
  const [errors, setErrors] = useState({});
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [step, setStep] = useState(1);
  // ================= ACCESSORIES =================
  const [accPackage, setAccPackage] = useState("");
  const [accPackageList, setAccPackageList] = useState([]);
  const [accAmount, setAccAmount] = useState(0);
  const [accDiscount, setAccDiscount] = useState(0);
  const [accTotalAmount, setAccTotalAmount] = useState(0);

  const [accCategory, setAccCategory] = useState("");
  const [accCategoryList, setAccCategoryList] = useState([]);

  const [accPartName, setAccPartName] = useState("");
  const [accPartNameList, setAccPartNameList] = useState([]);
  const [accPartNo, setAccPartNo] = useState("");
  const [accPartNoList, setAccPartNoList] = useState([]);
  const [accMrp, setAccMrp] = useState(0);
  const [accQty, setAccQty] = useState(1);
  const [accOtherGrid, setAccOtherGrid] = useState([]);
  const [accFinalTotal, setAccFinalTotal] = useState(0);
  const [showAccPopup, setShowAccPopup] = useState(false);
  const [accPackageDetails, setAccPackageDetails] = useState([]);
  // STEP 5 STATES

  const [warrantyType, setWarrantyType] = useState("");
  const [warrantyAmount, setWarrantyAmount] = useState(0);

  const [amcType, setAmcType] = useState("");
  const [amcAmount, setAmcAmount] = useState(0);

  const [roadSide, setRoadSide] = useState(0);

  const [logistics, setLogistics] = useState(false);
  const [logisticsAmount, setLogisticsAmount] = useState(0);

  const [fastTag, setFastTag] = useState(false);
  const [fastTagAmount, setFastTagAmount] = useState(600);

  const [nitrogen, setNitrogen] = useState(false);
  const [nitrogenAmount, setNitrogenAmount] = useState(0);

  const [exchangeAmount, setExchangeAmount] = useState(0);

  const [otherType, setOtherType] = useState("");
  const [otherAmount, setOtherAmount] = useState(0);
  const [otherGrid, setOtherGrid] = useState([]);
  const [otherValue, setOtherValue] = useState("");
  // ✅ STEP 5 SEPARATE STATE
  const [step5OtherType, setStep5OtherType] = useState("");
  const [step5OtherAmount, setStep5OtherAmount] = useState("");
  const [step5OtherGrid, setStep5OtherGrid] = useState([]);
  const [mode, setMode] = useState("ADD"); // ADD | EDIT | APPROVE
  const [custRemark1, setCustRemark1] = useState("");
  const [custRemark2, setCustRemark2] = useState("");
  const [custRemark3, setCustRemark3] = useState("");
  const editUnqid = location.state?.unqid;
  const viewUnqid = location.state?.viewUnqid;
  const [status, setStatus] = useState("");
  const [sp841, setSp841] = useState("");
  const [sp842, setSp842] = useState("");
  const [sp844, setSp844] = useState("");
  const [sp845, setSp845] = useState("");
  const [sp846, setSp846] = useState("");

  const SalutationOptions = [
    { value: "MR", label: "MR" },
    { value: "MRS", label: "MRS" },
    { value: "MISS", label: "MISS" },
    { value: "M/S", label: "M/S" },
    { value: "DR", label: "DR" },
  ];
  const DocketTypeOptions = [
    { value: "Regular Docket", label: "Regular Docket" },
    { value: "CSD Docket", label: "CSD Docket" },
    { value: "Leasee / Leassor", label: "Leasee / Leassor" },
  ];
  const RelationshipOptions = [
    { value: "Mother", label: "Mother" },
    { value: "Father", label: "Father" },
    { value: "Daughter", label: "Daughter" },
    { value: "Son", label: "Son" },
    { value: "Sister", label: "Sister" },
    { value: "Husband", label: "Husband" },
    { value: "Wife", label: "Wife" },
    { value: "Brother", label: "Brother" },

    { value: "Brother-in-law", label: "Brother-in-law" },
    { value: "Sister-in-law", label: "Sister-in-law" },
    { value: "Daughter-in-law", label: "Daughter-in-law" },
    { value: "Father-in-law", label: "Father-in-law" },
    { value: "Mother-in-law", label: "Mother-in-law" },

    { value: "Uncle", label: "Uncle" },
    { value: "Aunt", label: "Aunt" },
    { value: "Nephew", label: "Nephew" },
    { value: "Niece", label: "Niece" },
    { value: "Cousin", label: "Cousin" },

    { value: "Grand Son", label: "Grand Son" },
    { value: "Grand Daughter", label: "Grand Daughter" },
    { value: "Grand Mother", label: "Grand Mother" },
    { value: "Grand Father", label: "Grand Father" },
  ];
  useEffect(() => {
    if (editUnqid) {
      setMode("EDIT");
      sessionStorage.setItem("docket_unqid", editUnqid);

      loadEditData(editUnqid); // you already have edit API
    }
  }, []);
  useEffect(() => {
    if (viewUnqid) {
      setMode("VIEW");
      sessionStorage.setItem("docket_unqid", viewUnqid);

      loadViewData(viewUnqid); // you already have edit API
    }
  }, []);

  //------------------SCHEME ADD BUTTON WORKING
  const handleAddScheme = () => {
    if (!schemeType || !schemeName || !schemeAmount) {
      alert("Please fill all scheme fields");
      return;
    }
    const selectedSchemeNameObj = schemeNameList.find(
      (o) => o.value === schemeName,
    );
    const newRow = {
      id: Date.now(),
      schemeType: schemeType,
      schemeName: selectedSchemeNameObj?.label || "",
      schemeAmount: parseFloat(schemeAmount || 0),
      schemeId: schemeName,
    };
    const updatedGrid = [...schemeGrid, newRow];
    setSchemeGrid(updatedGrid);
    const totalScheme = updatedGrid.reduce(
      (sum, row) => sum + parseFloat(row.schemeAmount || 0),
      0,
    );
    const discount = parseFloat(specialDiscount || 0);
    setSchemesLess(totalScheme + discount);
    if (schemeType === "Corporate") {
      console.log("Corporate applied:", schemeAmount);
    } else if (schemeType === "Exchange") {
      console.log("Exchange applied:", schemeAmount);
    } else if (schemeType === "Loyality") {
      console.log("Loyalty applied:", schemeAmount);
    } else if (schemeType.includes("Dealer")) {
      console.log("Dealer applied:", schemeAmount);
    }
    setSchemeType("");
    setSchemeName("");
    setSchemeAmount("0");
  };
  //------------------SCHEME DELETE BUTTON WORKING
  const handleDeleteScheme = (id) => {
    const updatedGrid = schemeGrid.filter((row) => row.id !== id);
    setSchemeGrid(updatedGrid);
    const totalScheme = updatedGrid.reduce(
      (sum, row) => sum + parseFloat(row.schemeAmount || 0),
      0,
    );
    const discount = parseFloat(specialDiscount || 0);
    setSchemesLess(totalScheme + discount);
  };

  //------------------ACCESSORY HANDLING
  const handleAddAccessory = () => {
    if (!accCategory || !accPartName || !accPartNo) {
      alert("Please select category, part name and part no");
      return;
    }

    const categoryObj = accCategoryList.find((o) => o.value === accCategory);
    const partNameObj = accPartNameList.find((o) => o.value === accPartName);
    const partNoObj = accPartNoList.find((o) => o.value === accPartNo);

    const newRow = {
      id: Date.now(),

      category: categoryObj?.label || "",
      partName: partNameObj?.label || "",
      partNo: partNoObj?.label || "",

      mrp: parseFloat(accMrp || 0),
      qty: parseInt(accQty || 1),
      total: parseFloat(accMrp || 0) * parseInt(accQty || 1),
    };

    setAccOtherGrid([...accOtherGrid, newRow]);

    setAccCategory("");
    setAccPartName("");
    setAccPartNo("");
    setAccMrp(0);
    setAccQty(1);
  };

  const handleDeleteAccessory = (id) => {
    setAccOtherGrid(accOtherGrid.filter((row) => row.id !== id));
  };
  //------------------SCHEME AMOUNT WORKING
  useEffect(() => {
    const totalScheme = schemeGrid.reduce(
      (sum, row) => sum + parseFloat(row.schemeAmount || 0),
      0,
    );
    const discount = parseFloat(specialDiscount || 0);
    setSchemesLess(totalScheme + discount);
  }, [specialDiscount, schemeGrid]);
  //------------------SUB TOTAL WORKING
  useEffect(() => {
    const ex = parseFloat(exShowroom || 0);
    const sche = parseFloat(schemesLess || 0);
    const cess = parseFloat(vehicleCess || 0);
    const tcsVal = parseFloat(tcs || 0);
    const subtotalValue = ex - sche + cess + tcsVal;
    setSubTotal(subtotalValue);
  }, [exShowroom, schemesLess, vehicleCess, tcs]);
  //------------------SPECIAL DISCOUNT WORKING
  useEffect(() => {
    const totalScheme = schemeGrid.reduce(
      (sum, row) => sum + parseFloat(row.schemeAmount || 0),
      0,
    );
    const discount = parseFloat(specialDiscount || 0);
    setSchemesLess(totalScheme + discount);
  }, [specialDiscount, schemeGrid]);
  //------------------STYLE SECTION
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };
  //------------------EXIT BUTTON
  const handleExit = () => {
    navigate("/BookingDocketGrid");
  };
  //------------------FETCH IP ADDRESS
  useEffect(() => {
    axios
      .get("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);
  //------------------STYLE SECTION
  const inputStyle = (error) => ({
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "14px",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap",
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  //------------------LOAD DOCKET NO
  useEffect(() => {
    if (!editUnqid && !viewUnqid) {
      loadMaxDocketNo();
    }
  }, []);
  const loadMaxDocketNo = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-max-docket",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      if (data.err === "0") {
        setDocketNo(data.mx);
      }
    } catch (err) {
      console.error("Max docket fetch failed:", err);
    }
  };
  //------------------UPLOAD FILE
  const uploadFile = async (file, docType, docSide = "") => {
    if (!file) {
      alert("Select file first");
      return "";
    }
    const formData = new FormData();
    formData.append("docType", docType);
    formData.append("docSide", docSide);
    formData.append("file", file);
    try {
      const res = await axios.post(
        "/api/booking-docket/upload-file",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      return res.data.filePath;
    } catch (err) {
      console.error("UPLOAD ERROR:", err);
      alert("Upload error");
      return "";
    }
  };
  //------------------LOAD ENQURIRY NO
  useEffect(() => {
    loadEnquiryNumbers();
  }, []);
  const loadEnquiryNumbers = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-enquiry-list",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      console.log(data);
      const options = (data || []).map((item) => ({
        value: item.sp_352,
        label: item.sp_357,
      }));
      setEnquirynoList(options);
    } catch (err) {
      console.error("Enquiry load failed:", err);
      setEnquirynoList([]);
    }
  };
  //------------------LOAD BRANCH
  useEffect(() => {
    if (userId) {
      loadBranchList();
    }
  }, [userId]);

  const loadBranchList = async () => {
    try {
      console.log("Sending userId:", userId);

      const res = await apiFetch(
        "/api/booking/get-branch-list",
        {
          method: "POST",
          body: JSON.stringify({ userId }), // ✅ FIXED
        },
      );

      const data = await res.json();
      console.log("Branch API Response:", data);

      const options = Array.isArray(data)
        ? data.map((item) => ({
            value: item.sp_602 || item.data,
            label: item.sp_607 || item.value,
          }))
        : [];

      setBranchList(options);
    } catch (err) {
      console.error("Branch load failed:", err);
      setBranchList([]);
    }
  };
  //------------------STATE LAOD
  useEffect(() => {
    loadStateList();
  }, []);
  const loadStateList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-state-list",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      const stateData = data.states || [];
      const options = stateData.map((item) => ({
        value: String(item.sp_772),
        label: item.sp_777,
      }));
      setStateList(options);
      console.log("StateList sample:", options[0]);
      console.log("Type of option value:", typeof options[0]?.value);
      // Don't override state in EDIT mode or when state already selected.
      if (mode !== "EDIT" && !State && data.pa_value) {
        const pv = String(data.pa_value);
        const matched =
          options.find((o) => o.value === pv) ||
          options.find(
            (o) => (o.label || "").toLowerCase() === pv.toLowerCase(),
          );
        if (matched) setState(matched.value);
      }
    } catch (err) {
      console.error("State load failed:", err);
      setStateList([]);
    }
  };

  //------------------CITY LOAD
  useEffect(() => {
    if (State) {
      loadCityList(State);
    } else {
      setCityList([]);
      setCity("");
    }
  }, [State]);
  const loadCityList = async (stateValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-city-list",
        {
          method: "POST",
          body: JSON.stringify({ state: stateValue }),
        },
      );
      const data = await res.json();
      setCityList(data.cities || []);
    } catch (err) {
      console.error("City load failed:", err);
      setCityList([]);
    }
  };
  //------------------AREA LOAD
  useEffect(() => {
    if (City) {
      loadAreaList(City);
    } else {
      setAreaList([]);
      setArea("");
    }
  }, [City]);
  const loadAreaList = async (cityValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-area-list",
        {
          method: "POST",
          body: JSON.stringify({ city: cityValue }),
        },
      );
      const data = await res.json();
      setAreaList(data.areas || []);
    } catch (err) {
      console.error("Area load failed:", err);
      setAreaList([]);
    }
  };
  //------------------ZIP CODE LOAD
  useEffect(() => {
    if (Area) {
      loadZipCode(Area);
      setZipAutoLoaded(true);
    } else {
      setZipcode("");
      setZipAutoLoaded(false);
    }
  }, [Area]);
  const loadZipCode = async (areaValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-area-zip",
        {
          method: "POST",
          body: JSON.stringify({ area: areaValue }),
        },
      );
      const data = await res.json();
      if (zipAutoLoaded) {
        setZipcode(data.zip_code || "");
      }
    } catch (err) {
      console.error("Zip load failed:", err);
      setZipcode("");
    }
  };
  //------------------CITY SAVE CITY MASTER
  const handleCitySave = async () => {
    if (!newCityName.trim()) {
      alert("Please enter city name");
      return;
    }
    try {
      const res = await apiFetch(
        "/api/booking/city/insert",
        {
          method: "POST",
          body: JSON.stringify({ state: newCityStateName, city: newCityName }),
        },
      );
      const data = await res.json();

      setShowCityModal(false);
      setNewCityName("");
      loadCityList(State);
    } catch (err) {
      console.error("City save failed:", err);
      alert("Failed to save city");
    }
  };
  //------------------AREA SAVE AREA MASTER
  const handleAreaSave = async () => {
    if (!newAreaName.trim()) {
      alert("Please enter area name");
      return;
    }
    if (!newZipCode.trim()) {
      alert("Please enter zip code");
      return;
    }

    try {
      const res = await apiFetch(
        "/api/booking/area/insert",
        {
          method: "POST",
          body: JSON.stringify({
            city: City,
            area: newAreaName,
            zip: newZipCode,
          }),
        },
      );

      const data = await res.json();
      alert(data.message);

      setShowAreaModal(false);
      setNewAreaName("");
      setNewZipCode("");

      // 🔥 IMPORTANT FIX
      const cityVal = City;
      setAreaList([]); // clear first
      await loadAreaList(cityVal); // reload fresh
    } catch (err) {
      console.error("Area save failed:", err);
      alert("Failed to save area");
    }
  };
  //------------------LOAD DATA WHEN SELECT ENQUIRY
  const loadEnquiryData = async (enqno) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-enquiry-data",
        {
          method: "POST",
          body: JSON.stringify({
            enqno,
          }),
        },
      );
      const d = await res.json();
      if (!d) return;
      setName(d.sp_360 || "");
      setPrintName(d.sp_360 || "");
      setFatherName(d.sp_361 || "");
      setBranch(d.sp_362 || "");
      setMobileNo(d.sp_363 || "");
      setAddress(d.sp_365 || "");
      setState(String(d.sp_366 || ""));
      await loadCityList(String(d.sp_366));
      setCity(String(d.sp_367));
      await loadAreaList(d.sp_367);
      setArea(String(d.sp_368));
      await loadZipCode(d.sp_368);
      setEmail(d.sp_369 || "");
      if (d.sp_376?.includes("Regular")) {
        setDockettype("Regular Docket");
      } else {
        setDockettype("CSD Docket");
      }
      setPanCard(d.sp_420 || "");
      setGSTIN(d.sp_419 || "");
      setSalutation(d.sp_417 || "");
    } catch (err) {
      console.error("Enquiry fetch failed:", err);
    }
  };
  //------------------DOCKET STEP-1 SAVE WORKING*(CUSTOMER DETAILS)
  const handleSave = async () => {
    try {
      const payload = {
        sp_733: userId,
        sp_734: ipAddress,
        sp_735: serverIp,
        sp_737: docketDate || new Date().toISOString().slice(0, 10),
        sp_738: DocketNo,
        sp_739: Salutation,
        sp_740: Name,
        sp_759: PrintName,
        sp_879: FatherName,
        sp_741: Address,
        sp_742: City,
        sp_743: Area,
        sp_859: State,
        sp_744: Email,
        sp_745: MobileNo,
        sp_769: ContactNo,
        sp_768: Zipcode,
        sp_746: Aadhaar,
        sp_766: BirthDate || "1900-01-01",
        sp_767: AnniversaryDate || "1900-01-01",
        sp_871: NomineeName,
        sp_872: NomineeAge,
        sp_873: NomineeRelation,
        sp_874: NomineeMobile,
        sp_747: PanCard,
        sp_748: GSTIN,
        sp_861: Dockettype,
        sp_860: Branch,
        sp_909: Enquiryno || "0",
        sp_935: BookingDMSId,
        sp_770: aadhaarFrontPath,
        sp_869: aadhaarBackPath,
        sp_771: panPath,
        sp_897: gstPath,
        sp_934: commitmentPath,
      };
      console.log("SAVE PAYLOAD =>", payload);
      const res = await apiFetch(
        "/api/booking/save-docket-p1",

        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();
      console.log("SAVE RESPONSE =>", data);
      if (data.err === "0") {
        alert("Saved Successfully ✅");
        sessionStorage.setItem("docket_unqid", data.docket_unqid);
        return true;
      } else {
        alert(data.err);
        return false;
      }
    } catch (err) {
      console.error("SAVE ERROR FULL =>", err.response?.data || err.message);
      alert(err.response?.data?.err || "Server crashed – check console");
      alert("Server error");
      return false;
    }
  };
  //-----------------FETCH SCNAME LIST
  useEffect(() => {
    loadSCList();
  }, []);
  const loadSCList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-sc-list",
        {
          method: "POST",
          //  body: JSON.stringify({ state: stateValue }),
        },
      );
      const data = await res.json();
      console.log("SC RAW DATA =>", data);
      setSaleConsultantList(data || []);
    } catch (err) {
      console.error("SC load failed:", err);
    }
  };
  //------------------FETCH TL AND MANAGER BY SC NAME SELECTION
  const loadSCHierarchy = async (scUnq) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-sc-hierarchy",
        {
          method: "POST",
          body: JSON.stringify({ scUnq: scUnq }),
        },
      );
      const data = await res.json();
      if (data.err === "0") {
        setTeamLeader(data.tl || "");
        setManager(data.head || "");
      }
    } catch (err) {
      console.error("Hierarchy load failed:", err);
    }
  };
  //------------------FETCH MODEL
  useEffect(() => {
    loadModelList();
  }, []);
  const loadModelList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-model-list",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      console.log("MODEL LIST =>", data);
      setModelList(data || []);
    } catch (err) {
      console.error("Model load failed:", err);
      setModelList([]);
    }
  };
  //------------------FETCH VARIANT ON MODEL SELECTION
  useEffect(() => {
    if (model && fuel) {
      loadVariantList(model, fuel);
    } else {
      setVariantList([]);
      setVariant("");
    }
  }, [model, fuel]);
  const loadVariantList = async (modelValue, fuelValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-variant-list",
        {
          method: "POST",
          body: JSON.stringify({ model: modelValue, fuel: fuelValue }),
        },
      );
      const data = await res.json();
      console.log("VARIANT LIST =>", data);
      setVariantList(data || []);
    } catch (err) {
      console.error("Variant load failed:", err);
      setVariantList([]);
    }
  };
  //------------------FETCH COLOR ON VARIANT SELECTION
  useEffect(() => {
    if (variant) {
      loadColorList(model);
    } else {
      setColorList([]);
      setColor("");
    }
  }, [variant]);
  const loadColorList = async (modelValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-color-list",
        { method: "POST", body: JSON.stringify({ model: modelValue }) },
      );
      const data = await res.json();
      setColorList(data || []);
    } catch (err) {
      console.error("Color load failed:", err);
      setColorList([]);
    }
  };
  //------------------FETCH SPECIFIC CODE ON VARIANT SELECTION
  const loadSpCode = async (variantValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-sp-code",
        { method: "POST", body: JSON.stringify({ variant: variantValue }) },
      );
      const data = await res.json();
      setSpecificCode(data.sp_code || "0");
    } catch (err) {
      console.error("SP CODE LOAD FAILED =>", err);
      setSpecificCode("0");
    }
  };
  //------------------FETCH MANUFACTURE YEAR ON VARIANT SELECTION
  useEffect(() => {
    if (variant) {
      const currentYear = new window.Date().getFullYear();
      setManufacturingYear(currentYear.toString());
    } else {
      setManufacturingYear("");
    }
  }, [variant]);
  //------------------FETCH SOURCE OF BOOKING
  useEffect(() => {
    loadSourceBookingList();
  }, []);
  const loadSourceBookingList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-source-list",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      const options = (data || []).map((item) => ({
        value: item.zm01_1,
        label: item.zm01_1,
      }));
      setSourceBookingList(options);
    } catch (err) {
      console.error("Source load failed:", err);
      setSourceBookingList([]);
    }
  };
  //------------------FETCH HPN LIST
  useEffect(() => {
    loadHpnList();
  }, []);
  const loadHpnList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-hpn-list",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      setHpnList(data || []);
    } catch (err) {
      console.error("HPN LOAD FAILED =>", err);
      setHpnList([]);
    }
  };
  //------------------FETCH HPN BRANCH ON HPN SELECTION
  useEffect(() => {
    if (hpn) {
      loadHpnBranchList(hpn);
    } else {
      setHpnBranchList([]);
      setHpnBranch("");
    }
  }, [hpn]);
  const loadHpnBranchList = async (hpnValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-hpn-branch-list",
        {
          method: "POST",
          body: JSON.stringify({ hpn: hpnValue }),
        },
      );
      const data = await res.json();
      setHpnBranchList(data || []);
    } catch (err) {
      console.error("HPN BRANCH LOAD FAILED =>", err);
      setHpnBranchList([]);
    }
  };
  // ------------------ LOAD SCHEME TYPE WHEN MODEL SELECTED ------------------
  useEffect(() => {
    if (model) {
      loadSchemeTypeList(model);
    } else {
      setSchemeTypeList([]);
      setSchemeType("");
    }
  }, [model]);
  const loadSchemeTypeList = async (modelValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-scheme-type-list",
        { method: "POST", body: JSON.stringify({ model: modelValue }) },
      );
      const data = await res.json();
      setSchemeTypeList(data || []);
    } catch (err) {
      console.error("Scheme Type load failed:", err);
      setSchemeTypeList([]);
    }
  };
  // ------------------ LOAD SCHEME NAME WHEN TYPE + MODEL SELECTED ------------------
  useEffect(() => {
    if (model && schemeType) {
      loadSchemeNameList(model, schemeType);
    } else {
      setSchemeNameList([]);
      setSchemeName("");
    }
  }, [model, schemeType]);
  const loadSchemeNameList = async (modelValue, typeValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-scheme-name-list",
        {
          method: "POST",
          body: JSON.stringify({ model: modelValue, schemeType: typeValue }),
        },
      );
      const data = await res.json();
      setSchemeNameList(data || []);
    } catch (err) {
      console.error("Scheme Name load failed:", err);
      setSchemeNameList([]);
    }
  };
  // ------------------ LOAD SCHEME AMOUNT ------------------
  useEffect(() => {
    if (model && variant && schemeType && schemeName) {
      loadSchemeAmount();
    } else {
      setSchemeAmount("0");
    }
  }, [model, variant, schemeType, schemeName]);
  const loadSchemeAmount = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-scheme-amount",
        {
          method: "POST",
          body: JSON.stringify({
            model,
            variant,
            schemeType,
            schemeId: schemeName,
          }),
        },
      );
      const data = await res.json();
      setSchemeAmount(data.amt || "0");
    } catch (err) {
      console.error("Scheme Amount load failed:", err);
      setSchemeAmount("0");
    }
  };
  //------------------LOAD EX-SHOWROOM VEHICLECC AND TCS
  const loadVariantDetails = async () => {
    try {
      if (!variant || !color) return;
      const payload = {
        variant: variant,
        color: color,
        docketDate: docketDate || new Date().toISOString().slice(0, 10),
        fuel: fuel,
        state: State,
        rtoCity: City,
        vehicleOwnStatus: vehicleOwnStatus,
      };
      console.log("VARIANT MASTER PAYLOAD =>", payload);
      const res = await apiFetch(
        "/api/booking/get-variant-details",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      console.log(data);
      if (!data || data.err !== "0") {
        console.warn("No variant master data found");
        return;
      }
      const d = data.details;
      console.log(payload);
      if (!d) return;
      console.log(d.exshowroom);
      setExShowroom(Number(d.exshowroom || 0));
      setVehicleCess(Number(d.cess || 0));
      setTcs(Number(d.tcsamt || 0));
      setVehicleCC(Number(d.vehiclecc || 0));
      console.log("VARIANT MASTER RESULT =>", d);
    } catch (err) {
      console.error("VARIANT DETAILS LOAD FAILED =>", err);
    }
  };
  //------------------CALCULATION FUNCTION
  useEffect(() => {
    calculateAll();
  }, [
    exShowroom,
    schemesLess,
    vehicleCess,
    tcs,
    insuranceMaster,
    addZD,
    addEP,
    addKP,
    addRTI,
    addCM,
    addPB,
    addNilDep,
    addRSA,
    addEmiCover,
    addLossIncome,
    addTowing,
    addBatteryCover,
    addTyreCover,
    addEmergency,
    addDailyAllowance,
    addConsumables,
    addChargerProtection,
    rtoAmount,
    rtoTemporary,
    municipalTax,
    municipalAmount,
    trcAmount,
    trcSpecificAmount,
  ]);
  const calculateAll = () => {
    const num = (v) => Number(v || 0);

    /* ================= VEHICLE ================= */

    const ex = num(exShowroom);
    const schemes = num(schemesLess);
    const cess = num(vehicleCess);
    const tcsPercent = num(tcs); // assume this is % entered

    let subTotal = ex - schemes + cess;

    let tcsAmount = 0;
    if (subTotal > 1000000) {
      tcsAmount = (subTotal * tcsPercent) / 100;
    }

    subTotal += tcsAmount;

    /* ================= INSURANCE ================= */

    let finalInsurance = 0;

    if (insuranceMaster && ex > 0) {
      const idv = (ex * num(insuranceMaster.idv)) / 100;
      const od = (idv * num(insuranceMaster.insurance_per)) / 100;
      const discount = (od * num(insuranceMaster.discount_per)) / 100;
      const afterDiscount = od - discount;

      const percentAddon = (enabled, percent) =>
        enabled ? (afterDiscount * num(percent)) / 100 : 0;

      const fixedAddon = (enabled, value) => (enabled ? num(value) : 0);

      const totalBeforeGST =
        afterDiscount +
        percentAddon(addZD, insuranceMaster.zd_per) +
        percentAddon(addEP, insuranceMaster.ep_per) +
        percentAddon(addKP, insuranceMaster.kp_per) +
        percentAddon(addRTI, insuranceMaster.rti_per) +
        percentAddon(addCM, insuranceMaster.cm_per) +
        percentAddon(addPB, insuranceMaster.pb_per) +
        num(insuranceMaster.pa_cover) +
        num(insuranceMaster.third_party) +
        num(insuranceMaster.paid_driver) +
        fixedAddon(addNilDep, insuranceMaster.nil_dep) +
        fixedAddon(addRSA, insuranceMaster.rsa) +
        fixedAddon(addEmiCover, insuranceMaster.emi_cover) +
        fixedAddon(addLossIncome, insuranceMaster.loss_income) +
        fixedAddon(addTowing, insuranceMaster.towing) +
        fixedAddon(addBatteryCover, insuranceMaster.battery_cover) +
        fixedAddon(addTyreCover, insuranceMaster.tyre_cover) +
        fixedAddon(addEmergency, insuranceMaster.emergency_exp) +
        fixedAddon(addDailyAllowance, insuranceMaster.daily_allow) +
        fixedAddon(addConsumables, insuranceMaster.consumables) +
        fixedAddon(addChargerProtection, insuranceMaster.charger_protection);

      const gstAmount = (totalBeforeGST * num(insuranceMaster.gst)) / 100;

      finalInsurance = totalBeforeGST + gstAmount;
    }

    /* ================= RTO ================= */

    const rtoFinal =
      num(rtoAmount) +
      num(rtoTemporary) +
      (municipalTax ? num(municipalAmount) : 0);

    /* ================= TRC ================= */

    const trcFinal = num(trcAmount) + num(trcSpecificAmount);

    /* ================= FINAL PACKAGE ================= */

    const finalPackage = subTotal + finalInsurance + rtoFinal + trcFinal;

    /* ================= STATE UPDATE ================= */

    setSubTotal(subTotal.toFixed(2));
    setInsuranceAmount(finalInsurance.toFixed(2));
    setPackagePrice(finalPackage.toFixed(2));
  };

  useEffect(() => {
    const amt = parseFloat(accAmount || 0);
    const disc = parseFloat(accDiscount || 0);
    setAccTotalAmount((amt - disc).toFixed(2));
  }, [accAmount, accDiscount]);
  //------------------DOCKET STEP 2 SAVE WORKING(VEHICLE SECTION)
  const toNum = (v) =>
    v === "" || v === null || v === undefined || isNaN(v) ? 0 : Number(v);
  const handleSaveStep2 = async () => {
    try {
      const docketUnqid = sessionStorage.getItem("docket_unqid");
      const payload = {
        sp_905: docketUnqid,
        sp_756: saleConsultant || "",
        sp_757: teamLeader || "",
        sp_758: manager || "",
        sp_762: fuel || "",
        sp_749: model || "",
        sp_750: variant || "",
        sp_751: color || "",
        sp_870: manufacturingYear || "",
        sp_760: deliveryDate || "",
        sp_765: sourceBooking || "",
        sp_772: financeType || "",
        sp_773: companyAuthorised || "",
        sp_774: hpn || "",
        sp_775: hpnBranch || "",
        sp_777: toNum(loanAmount),
        sp_776: toNum(netDisbursedAmount),
        sp_785: toNum(specialDiscount),
        sp_786: toNum(exShowroom),
        sp_787: toNum(schemesLess),
        sp_788: toNum(subTotal),
        sp_752: toNum(packagePrice),
        sp_789: priceProtection ? "1" : "",
        sp_908: specificCode || "",
        sp_778: 0,
        sp_779: 0,
        sp_780: 0,
        sp_781: 0,
        sp_782: 0,
        sp_783: 0,
        sp_784: 0,
        sp_811: 0,
        sp_830: 0,
        sp_831: 0,
        sp_832: 0,
        sp_833: 0,
        sp_834: 0,
        sp_835: 0,
        sp_836: 0,
        sp_837: 0,
        sp_801: 0,
        sp_796: 0,
        sp_795: 0,
        sp_799: 0,
        sp_898: 0,
        sp_806: 0,
        sp_807: 0,
        sp_808: 0,
        sp_809: 0,
        sp_810: 0,
        sp_899: 0,
      };
      const res = await apiFetch(
        "/api/booking/save-docket-p2",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      console.log(payload);
      if (data.err === "0") {
        for (const row of schemeGrid) {
          await apiFetch(
            "/api/booking/save-scheme-child",
            {
              method: "POST",
              body: JSON.stringify({
                sp_73_3_1: docketUnqid,
                sp_73_3_4: row.schemeType,
                sp_73_3_5: row.schemeName,
                sp_73_3_6: row.schemeAmount,
                sp_73_3_7: row.schemeId,
              }),
            },
          );
        }
        alert("Vehicle + Schemes Saved Successfully ✅");
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error("STEP2 ERROR =>", err.response?.data || err.message);
      alert("Step 2 Save Failed");
    }
  };

  const [rtoFields, setRtoFields] = useState({
    amount: 0,
    addLess: 0,
    rtoRate: 0,
    rtoTaxSurcharge: 0,
    greenTax: 0,
    regFee: 0,
    hpn: 0,
    duplicate: 0,
    smartCard: 0,
    other: 0,
    bhYear: 0,
    localTax: 0,
    roadSafetyTax: 0,
    mcdCharge: 0,
    otherCharges: 0,
    cngKit: 0,
    numberPlate: 0,
    excludingTax: 0,
    scrapage: false,
    scrapageAmount: 0,
  });

  useEffect(() => {
    loadInsuranceCompanyList();
  }, []);
  const loadInsuranceCompanyList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-insurance-company",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await res.json();
      console.log("INSURANCE RAW DATA =>", data);

      const options = (data || []).map((item) => ({
        value: item.value,
        label: item.label,
      }));

      setinsurancecompanyList(options);
    } catch (err) {
      console.error("Insurance company load failed:", err);
      setinsurancecompanyList([]);
    }
  };
  useEffect(() => {
    if (!insuranceMaster) return;
    // In edit flow, addon flags come from saved docket fields in `loadEditData`.
    // Do not overwrite them from insurance master defaults.
    if (mode === "EDIT") return;
    const hasMasterCheckedFlags =
      insuranceMaster.zd_checked !== undefined ||
      insuranceMaster.ep_checked !== undefined ||
      insuranceMaster.cm_checked !== undefined ||
      insuranceMaster.rti_checked !== undefined ||
      insuranceMaster.kp_checked !== undefined ||
      insuranceMaster.pb_checked !== undefined;
    if (!hasMasterCheckedFlags) return;
    const checked = (v) => v === 1 || v === "1" || v === true;
    setAddZD(checked(insuranceMaster.zd_checked));
    setAddEP(checked(insuranceMaster.ep_checked));
    setAddCM(checked(insuranceMaster.cm_checked));
    setAddRTI(checked(insuranceMaster.rti_checked));
    setAddKP(checked(insuranceMaster.kp_checked));
    setAddPB(checked(insuranceMaster.pb_checked));
  }, [insuranceMaster]);
  // ------------------ FETCH RTO DATA ------------------
  const fetchRTOData = async () => {
    try {
      if (!docketDate || !exShowroom || !vehicleCC || !State || !rtoType) {
        return;
      }
      const payload = {
        bookingDate: docketDate,
        exshowroom: Number(exShowroom),
        vehiclecc: Number(vehicleCC),
        rtotype: rtoType,
        rtostate: State,
      };
      console.log("RTO REQUEST:", payload);
      const res = await apiFetch(
        "/api/booking/rto-calculation",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      console.log("DATA: " + data);
      if (data && data.length > 0) {
        const rto = data[0];
        setRtoFields({
          amount: rto.amount || 0,
          addLess: rto.add_less || 0,
          rtoRate: rto.rtorate || 0,
          rtoTaxSurcharge: rto.rtosurcharge || 0,
          greenTax: rto.greentax || 0,
          regFee: rto.regfee || 0,
          hpn: rto.hpn || 0,
          duplicate: rto.duplicatecard || 0,
          smartCard: rto.smartcard || 0,
          other: rto.othercharge || 0,
          bhYear: rto.bh_year || rto.bhyear || 0,
          localTax: rto.localtax || 0,
          roadSafetyTax: rto.roadsafety || 0,
          mcdCharge: rto.mcdpkgcharge || 0,
          otherCharges: rto.othercharges || 0,
          cngKit: rto.cngkit || 0,
          numberPlate: rto.numberplate || 0,
          excludingTax: rto.excludingtax || 0,
          scrapage: false,
          scrapageAmount: Number(rto.scrappage) || 0,
        });
        calculateRTO(rto);
      }
    } catch (err) {
      console.error("RTO LOAD ERROR:", err);
    }
  };
  useEffect(() => {
    if (rtoType === "OutHouse") {
      setRtoAmount(0);
      setRtoTemporary(0);
      setMunicipalTax(false);
      setMunicipalAmount(0);

      setRtoFields({
        amount: 0,
        addLess: 0,
        rtoRate: 0,
        rtoTaxSurcharge: 0,
        greenTax: 0,
        regFee: 0,
        hpn: 0,
        duplicate: 0,
        smartCard: 0,
        other: 0,
        bhYear: 0,
        localTax: 0,
        roadSafetyTax: 0,
        mcdCharge: 0,
        otherCharges: 0,
        cngKit: 0,
        numberPlate: 0,
        excludingTax: 0,
        scrapage: false,
        scrapageAmount: 0,
      });
    }
  }, [rtoType]);
  // ------------------ RTO CALCULATION PART ------------------
  const calculateRTO = (rto) => {
    if (rtoType === "OutHouse") {
      setRtoAmount(0);
      return;
    }
    const exshowroom = Number(exShowroom) || 0;
    const rtorate = Number(rto.rtoRate || rto.rtorate) || 0;
    if (rtoType === "BH") {
      const bh_year = Number(rto.bhYear || 0);
      const pa_year = Number(rto.paYear || 0);
      const pa_percent = Number(rto.paPercent || 1);

      const rtorate = Number(rto.rtoRate || rto.rtorate || 0);

      const baseRto = (Number(exShowroom) * rtorate) / 100;

      const bhRto = (baseRto * bh_year * pa_year) / pa_percent;

      const otherCharges =
        Number(rto.greenTax || 0) +
        Number(rto.regFee || 0) +
        Number(rto.hpn || 0) +
        Number(rto.duplicate || 0) +
        Number(rto.smartCard || 0) +
        Number(rto.other || 0) +
        Number(rtoTemporary || 0) +
        Number(rto.localTax || 0) +
        Number(rto.mcdCharge || 0) +
        Number(rto.numberPlate || 0) +
        (municipalTax ? Number(municipalAmount || 0) : 0);

      const finalRto = bhRto + otherCharges;

      setRtoAmount(finalRto.toFixed(2));

      return;
    }
    const baseRto = (exshowroom * rtorate) / 100;
    let finalRtoBase = baseRto;
    if (rtoFields.scrapage === true) {
      const scrappagePercent = Number(rtoFields.scrapageAmount || 0);

      if (scrappagePercent > 0) {
        const scrappageAmount = (baseRto * scrappagePercent) / 100;
        finalRtoBase = baseRto - scrappageAmount;
      }
    }
    const surcharge =
      (finalRtoBase * (Number(rto.rtoTaxSurcharge || rto.rtosurcharge) || 0)) /
      100;
    const total =
      finalRtoBase +
      surcharge +
      Number(rto.greenTax || 0) +
      Number(rto.regFee || 0) +
      Number(rto.hpn || 0) +
      Number(rto.duplicate || 0) +
      Number(rto.smartCard || 0) +
      Number(rto.other || 0) +
      Number(rtoTemporary || 0) +
      Number(rto.localTax || 0) +
      Number(rto.mcdCharge || 0) +
      Number(rto.numberPlate || 0) +
      (municipalTax ? Number(municipalAmount || 0) : 0);

    setRtoAmount(total.toFixed(2));
  };
  useEffect(() => {
    if (
      docketDate &&
      Number(exShowroom) > 0 &&
      Number(vehicleCC) > 0 &&
      State &&
      rtoType
    ) {
      fetchRTOData();
    }
  }, [docketDate, exShowroom, vehicleCC, State, rtoType]);
  useEffect(() => {
    calculateRTO(rtoFields);
  }, [rtoType, rtoTemporary, municipalTax, municipalAmount, rtoFields]);
  useEffect(() => {
    calculateRTO(rtoFields);
  }, [rtoFields.scrapage, rtoFields.scrapageAmount]);

  // ------------------ DOCKET STEP-3 INS AND RTO PART SAVE CODE ------------------
  const handleFinalSave = async () => {
    try {
      const docketUnqid = sessionStorage.getItem("docket_unqid");
      const payload = {
        sp_905: docketUnqid,
        sp_752: Number(packagePrice) || 0,
        sp_790: insuranceType ?? "InHouse",
        sp_801: Number(insuranceMaster?.insurance_per) || 0,
        sp_803: Number(insuranceMaster?.discount_per) || 0,
        sp_804: 0,
        sp_823: Number(insuranceAmount) || 0,
        sp_911: insurancecompany || "",
        sp_912: addEP ? 1 : 0,
        sp_913: addRTI ? 1 : 0,
        sp_914: addCM ? 1 : 0,
        sp_915: addPB ? 1 : 0,
        sp_916: addKP ? 1 : 0,
        sp_917: addZD ? 1 : 0,
        sp_791: Number(insuranceMaster?.ep_per) || 0,
        sp_792: Number(insuranceMaster?.rti_per) || 0,
        sp_793: Number(insuranceMaster?.cm_per) || 0,
        sp_810: Number(insuranceMaster?.kp_per) || 0,
        sp_808: Number(insuranceMaster?.zd_per) || 0,
        sp_818: 0,
        sp_815: 0,
        sp_816: 0,
        sp_809: 0,
        sp_806: Number(insuranceMaster?.third_party) || 0,
        sp_807: Number(insuranceMaster?.pa_cover) || 0,
        sp_811: Number(insuranceMaster?.paid_driver) || 0,
        sp_812: 0,
        sp_817: 0,
        sp_799: Number(insuranceMaster?.idv) || 0,
        sp_800: 0,
        sp_821: 0,
        sp_824: 0,
        sp_825: 0,
        sp_813: Number(insuranceMaster?.gst) || 0,
        sp_814: 0,
        sp_819: 0,
        sp_820: 0,
        sp_794: Number(exShowroom) || 0,
        sp_827: Number(insuranceAmount) || 0,
        sp_893: Number(insuranceAmount) || 0,
        sp_894: 0,
        sp_901: "",
        sp_828: rtoType || "",
        sp_883: Number(rtoTemporary) || 0,
        sp_838: Number(rtoAmount) || 0,
        sp_895: Number(rtoAmount) || 0,
        sp_896: 0,
        sp_830: Number(rtoFields?.rtoRate) || 0,
        sp_831: Number(rtoFields?.rtoTaxSurcharge) || 0,
        sp_832: Number(rtoFields?.greenTax) || 0,
        sp_833: Number(rtoFields?.regFee) || 0,
        sp_834: Number(rtoFields?.hpn) || 0,
        sp_835: Number(rtoFields?.duplicate) || 0,
        sp_836: Number(rtoFields?.smartCard) || 0,
        sp_837: Number(rtoFields?.other) || 0,
        sp_855: vehicleOwnStatus === "one" ? 1 : 0,
        sp_839: City || "",
        sp_829: Number(exShowroom) || 0,
        sp_902: "",
        sp_907: trcType || "",
        sp_840: Number(trcAmount) || 0,
        sp_858: Number(trcSpecificNo) || 0,
        sp_868: Number(trcSpecificAmount) || 0,
        sp_903: "",
        // Save addon AMOUNTS only when the checkbox is selected, else 0.
        // (Previously we always saved the master amount, causing edit to show "checked" even if user unchecked.)
        sp_921: addDailyAllowance
          ? Number(insuranceMaster?.daily_allow || 0)
          : 0,
        sp_922: addNilDep ? Number(insuranceMaster?.nil_dep || 0) : 0,
        sp_923: addRSA ? Number(insuranceMaster?.rsa || 0) : 0,
        sp_924: addEmiCover ? Number(insuranceMaster?.emi_cover || 0) : 0,
        sp_925: addTyreCover ? Number(insuranceMaster?.tyre_cover || 0) : 0,
        sp_926: addLossIncome ? Number(insuranceMaster?.loss_income || 0) : 0,
        sp_927: addConsumables ? Number(insuranceMaster?.consumables || 0) : 0,
        sp_928: addTowing ? Number(insuranceMaster?.towing || 0) : 0,
        sp_929: addEmergency ? Number(insuranceMaster?.emergency_exp || 0) : 0,
        sp_930: addChargerProtection
          ? Number(insuranceMaster?.charger_protection || 0)
          : 0,
        sp_931: addBatteryCover
          ? Number(insuranceMaster?.battery_cover || 0)
          : 0,
        sp_936: Number(rtoFields?.scrapageAmount) || 0,
        sp_937: 0,
      };
      console.log("FINAL SAVE PAYLOAD:", payload);
      const res = await apiFetch(
        "/api/booking/save-docket-p3",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      if (data.err === "0") {
        alert("Final Save Successful ✅");
        return true;
      } else {
        alert(data.msg);
        return false;
      }
    } catch (err) {
      console.error("FINAL SAVE ERROR:", err);
      alert("Final Save Failed");
    }
  };
  //---------Package List
  useEffect(() => {
    if (model) {
      loadPackageList(model);
    } else {
      setAccPackageList([]);
      setAccPackage("");
    }
  }, [model]);
  const loadPackageList = async (modelValue) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-package-list",
        { method: "POST", body: JSON.stringify({ model: modelValue }) },
      );
      const data = await res.json();
      const options = (data || []).map((item) => ({
        value: item.sp_762,
        label: item.sp_767,
      }));

      setAccPackageList(options);
    } catch (err) {
      console.error("Package load failed:", err);
      setAccPackageList([]);
    }
  };
  const handlePackageChange = async (selected) => {
    const packageId = selected?.value || "";
    setAccPackage(packageId);

    if (!packageId) return;

    try {
      const res = await apiFetch(
        "/api/booking/get-package-detail",
        { method: "POST", body: JSON.stringify({ packageId }) },
      );
      const data = await res.json();
      const list = data.list || [];

      const rows = list.map((item, index) => ({
        id: index + 1,
        category: item.category,
        partName: item.sp_76_2,
        partNo: item.sp_76_3,
        mrp: Number(item.sp_76_5 || 0),
        qty: Number(item.sp_76_4 || 1),
        total: Number(item.sp_76_5 || 0) * Number(item.sp_76_4 || 1),
        discount: Number(item.sp_76_8 || 0),
      }));

      setAccPackageDetails(rows);

      let amount = 0;
      let discount = 0;

      rows.forEach((r) => {
        amount += r.total;
        discount += r.discount;
      });

      setAccAmount(amount.toFixed(2));
      setAccDiscount(discount.toFixed(2));
      setAccTotalAmount((amount - discount).toFixed(2));
    } catch (err) {
      console.error("PACKAGE DETAIL ERROR", err);
    }
  };
  useEffect(() => {
    loadCategoryList();
  }, []);

  const loadCategoryList = async () => {
    try {
      const res = await apiFetch(
        "/api/booking/get-category-list",
        { method: "POST" },
      );
      const data = await res.json();

      const options = (data || []).map((item) => ({
        value: item.unqid,
        label: item.category,
      }));

      setAccCategoryList(options);
    } catch (err) {
      console.error("CATEGORY LOAD FAILED =>", err);
      setAccCategoryList([]);
    }
  };
  const loadPartNames = async (categoryId) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-partname-list",
        { method: "POST", body: JSON.stringify({ category: categoryId }) },
      );
      const data = await res.json();

      if (data.err === "0") {
        setAccPartNameList(data.list || []);
      } else {
        setAccPartNameList([]);
      }
    } catch (err) {
      console.error("PART NAME LOAD ERROR:", err);
    }
  };
  const loadPartDetail = async (partId) => {
    try {
      const res = await apiFetch(
        "/api/booking/get-part-detail",
        { method: "POST", body: JSON.stringify({ partunq: partId }) },
      );
      const data = await res.json();

      console.log("PART DETAIL RESPONSE:", data);

      if (data.err === "0") {
        const d = data.data;

        const options = [
          {
            value: d.partno,
            label: d.partno,
            mrp: d.mrp,
          },
        ];

        setAccPartNoList(options);
        setAccPartNo(d.partno);
        setAccMrp(Number(d.mrp || 0));
      }
    } catch (err) {
      console.error("PART DETAIL ERROR:", err);
    }
  };
  const handleFinalAceessSave = async () => {
    try {
      const docketUnqid = sessionStorage.getItem("docket_unqid");

      const payload = {
        sp_905: docketUnqid,
        pkg_package: accPackage,
        pkg_amt: accAmount,
        pkg_discamt: accDiscount,
        pkg_totalamt: accTotalAmount,
        pkgprice: packagePrice,
        oth_pkg_tbamt: accFinalTotal,

        grid: accOtherGrid.map((row) => ({
          partunq: row.partNo,
          qty: row.qty,
          mrp: row.mrp,
          total: row.total,
        })),
      };

      const res = await apiFetch(
        "/api/booking/save-docket-p4",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();

      if (data.err === 0) {
        alert("Saved Successfully");
        return true;
      } else {
        alert(data.msg);
        return false;
      }
    } catch (err) {
      console.error(err);
      alert("Error while saving");
      return false;
    }
  };
  const handleAddOther = () => {
    if (!otherType || !otherAmount) {
      alert("Please select other type and amount");
      return;
    }
    const newRow = {
      id: Date.now(),
      type: otherType,
      amount: parseFloat(otherAmount || 0),
    };
    setOtherGrid([...otherGrid, newRow]);
    setOtherType("");
    setOtherAmount("");
  };
  const [warrantyList, setWarrantyList] = useState([]);

  const getWarranty = async (variantUnq, date) => {
    try {
      const res = await apiFetch(
        "/api/booking/warranty",
        { method: "POST", body: JSON.stringify({ variantunq: variantUnq, date: date }) },
      );
      const data = await res.json();

      if (data.err === "0") {
        const list = data.list || [];

        const formatted = list.map((item) => ({
          value: item.sp_782,
          label: item.sp_787,
        }));

        setWarrantyList(formatted);
      }
    } catch (err) {
      console.error("Warranty error", err);
    }
  };
  const loadWarrantyAmount = async (variant, warranty) => {
    try {
      const res = await apiFetch(
        "/api/booking/warranty-amount",
        { method: "POST", body: JSON.stringify({ variantunq: variant, warrantyunq: warranty }) },
      );
      const data = await res.json();

      if (data.err === "0") {
        setWarrantyAmount(data.amt || 0);
      } else {
        setWarrantyAmount(0);
      }
    } catch (err) {
      console.error("Warranty amount fetch error:", err);
      setWarrantyAmount(0);
    }
  };
  const [sotList, setSotList] = useState([]);
  const [sotAmount, setSotAmount] = useState(0);

  const getAMC = async (variant, docketDate) => {
    try {
      const res = await apiFetch(
        "/api/booking/sot-amc",
        { method: "POST", body: JSON.stringify({ variantunq: variant, date: docketDate }) },
      );
      const data = await res.json();
      console.log("AMC API RESPONSE:", data);
      const list = data.list || [];
      const formatted = list.map((item) => ({
        value: item.sp_792,
        label: item.sp_797,
      }));
      setSotList(formatted);
    } catch (err) {
      console.error("AMC fetch error:", err);
    }
  };

  const getAMCAmount = async (variant, sot) => {
    try {
      const res = await apiFetch(
        "/api/booking/sot-amc-amount",
        { method: "POST", body: JSON.stringify({ variantunq: variant, sotunq: sot }) },
      );
      const data = await res.json();
      if (data.err === "0") {
        setAmcAmount(data.amt || 0);
      }
    } catch (err) {
      console.error("AMC amount error:", err);
    }
  };

  const [otherList, setOtherList] = useState([]);

  useEffect(() => {
    if (step === 5) {
      getOtherList();
    }
  }, [step]);
  const getOtherList = async () => {
    try {
      const res = await apiFetch("/api/booking/other", { method: "POST" });
      const data = await res.json();
      const list = data?.result?.list || [];
      const formatted = list.map((item) => ({
        value: item.data,
        label: item.value,
      }));
      setOtherList(formatted);
    } catch (err) {
      console.error("OTHER LOAD ERROR:", err);
    }
  };
  // ✅ STEP 5 ADD FUNCTION (SEPARATE)
  const handleAddOtherStep5 = () => {
    if (!step5OtherType || !step5OtherAmount) {
      alert("Please select other type and amount");
      return;
    }
    const selected = otherList.find((o) => o.value === step5OtherType);
    const newRow = {
      id: Date.now(),
      type: selected?.label || "",
      value: selected?.value || "",
      amount: parseFloat(step5OtherAmount || 0),
    };
    setStep5OtherGrid((prev) => [...prev, newRow]);
    setStep5OtherType("");
    setStep5OtherAmount("");
  };
  // ✅ BOOKING DOCKET STEP-5 SAVE WORKING
  const handleSaveStep5 = async () => {
    try {
      const docketUnqid = sessionStorage.getItem("docket_unqid");
      const payload = {
        sp_905: docketUnqid,
        sp_847: warrantyType || "",
        sp_848: (warrantyAmount || "0").toString(),
        sp_862: amcType || "",
        sp_863: (amcAmount || "0").toString(),
        sp_864: (roadSide || "0").toString(),
        sp_850: logistics ? "1" : "0",
        sp_851: (logisticsAmount || "0").toString(),
        sp_852: fastTag ? "1" : "0",
        sp_853: (fastTagAmount || "0").toString(),
        sp_854: nitrogen ? "1" : "0",
        sp_856: (nitrogenAmount || "0").toString(),
        sp_920: (exchangeAmount || "0").toString(),
        sp_752: (packagePrice || "0").toString(),
        grid: step5OtherGrid.map((r) => ({ value: r.value, amount: r.amount })),
      };
      console.log("STEP 5 PAYLOAD:", payload);
      const res = await apiFetch(
        "/api/booking/save-docket-p5",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      if (data.err === "0") {
        alert("Step 5 Saved ✅");
        window.location.href = "/BookingDocketGrid";
      } else {
        alert(data.msg || "Error saving step 5");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };
  // ✅ BOOKING DOCKET STEP-6 SUBMIT BUTTON WORKING
  const handleSubmitStep6 = async () => {
    const docketUnqid = sessionStorage.getItem("docket_unqid");
    try {
      const payload = {
        sp_905: docketUnqid,
        sp_752: Number(packagePrice) || 0,
        sp_753: custRemark1,
        sp_754: custRemark2,
        sp_755: custRemark3,
      };
      console.log("STEP 6:", payload);
      const res = await apiFetch(
        "/api/booking/save-docket-p6",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      if (data.err === "0") {
        alert("Saved Successfully");
        navigate("/BookingDocketGrid");
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };
  // ✅ USEEFFECT FOR EDIT AND VIEW
  useEffect(() => {
    if (editUnqid) {
      loadEditData(editUnqid);
    }
  }, [editUnqid]);
  useEffect(() => {
    if (viewUnqid) {
      loadViewData(viewUnqid);
    }
  }, [viewUnqid]);
  useEffect(() => {
    if (insuranceMaster && Object.keys(insuranceMaster).length > 0) {
      calculateAll(); // ✅ your existing function
    }
  }, [insuranceMaster]);
  // ✅ BOOKING DOCKET EDIT WORKING
  const loadEditData = async (id) => {
    try {
      setMode("EDIT");
      const res = await apiFetch("/api/booking/edit", {
        method: "POST",
        body: JSON.stringify({ sp_732: id }),
      });
      const resData = await res.json();
      if (resData.err !== "0") {
        alert("Failed to load");
        return;
      }
      const d = resData.data;
      console.log("FULL EDIT DATA =>", d);
      const formatDate = (val) => {
        if (!val) return "";
        const parts = val.split("-");
        if (parts.length !== 3) return "";
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      };
      const toBool = (v) => {
        if (v === true) return true;
        if (v === false) return false;
        if (v === 1 || v === "1") return true;
        if (v === 0 || v === "0") return false;
        if (typeof v === "string") {
          const s = v.trim().toLowerCase();
          if (s === "true" || s === "yes" || s === "y") return true;
          if (s === "false" || s === "no" || s === "n") return false;
        }
        return Boolean(Number(v));
      };
      // ================= STEP 1 (FIXED MAPPING) =================
      setEnquiryno(d.sp_909 || "");
      setDocketNo(d.sp_738 || "");
      setDocketDate(formatDate(d.sp_737));
      setDockettype(d.sp_861 || "");
      setBranch(d.sp_860 || "");
      setSalutation(d.sp_739 || "");
      setName(d.sp_740 || "");
      setPrintName(d.sp_759 || "");
      setFatherName(d.sp_879 || "");
      setAddress(d.sp_741 || "");
      setEmail(d.sp_744 || "");
      setStatus(d.sp_884 || d.status || "");
      if (!StateList?.length) {
        try {
          await loadStateList();
        } catch {}
      }
      const rawState = String(d.sp_859 || "");
      const resolvedState =
        StateList.find((o) => o.value === rawState)?.value ||
        StateList.find(
          (o) => (o.label || "").toLowerCase() === rawState.toLowerCase(),
        )?.value ||
        rawState;
      const editState = resolvedState;
      const editCity = String(d.sp_742 || "");
      const editArea = String(d.sp_743 || "");
      const editZip = String(d.sp_768 || "");
      setState(editState);
      try {
        if (editState) await loadCityList(editState);
      } catch {}
      setCity(editCity);
      try {
        if (editCity) await loadAreaList(editCity);
      } catch {}
      setArea(editArea);
      try {
        if (editArea) {
          await loadZipCode(editArea);
          setZipAutoLoaded(true);
        }
      } catch {}
      setZipcode(editZip);
      setMobileNo(d.sp_745 || "");
      setContactNo(d.sp_769 || "");
      setBirthDate(formatDate(d.sp_766));
      setAnniversaryDate(formatDate(d.sp_767));
      setNomineeName(d.sp_871 || "");
      setNomineeAge(d.sp_872 || "");
      setNomineeRelation(d.sp_873 || "");
      setNomineeMobile(d.sp_874 || "");
      setAadhaar(d.sp_746 || "");
      setPanCard(d.sp_747 || "");
      setGSTIN(d.sp_748 || "");
      setBookingDMSId(d.sp_935 || d.booking_dms_id || d.bookingDmsId || "");
      setAadhaarFrontPath(d.sp_770 || "");
      setAadhaarBackPath(d.sp_869 || "");
      setPanPath(d.sp_771 || "");
      setGstPath(d.sp_897 || "");
      setCommitmentPath(d.sp_934 || "");
      // ================= STEP 2 =================
      setSaleConsultant(d.sp_756 || "");
      setTeamLeader(d.sp_757 || "");
      setManager(d.sp_758 || "");
      setFuel(d.sp_762 || "");
      setModel(d.sp_749 || "");
      if (d.sp_749) {
        await loadVariantList(d.sp_749);
      }
      setVariant(d.sp_750 || "");
      if (d.sp_750) {
        await loadColorList(d.sp_750);
      }
      setColor(d.sp_751 || "");
      setManufacturingYear(d.sp_799 || "");
      setDeliveryDate(formatDate(d.sp_760));
      setSourceBooking(d.sp_765 || "");
      setSpecificCode(d.sp_908 || "");
      setFinanceType(d.sp_772 || "");
      setCompanyAuthorised(d.sp_773 || "");
      setHpn(d.sp_774 || "");
      setHpnBranch(d.sp_775 || "");
      setLoanAmount(d.sp_777 || "");
      setNetDisbursedAmount(d.sp_776 || "");
      setSpecialDiscount(d.sp_785 || "");
      setExShowroom(Number(d.sp_786) || 0);
      setVehicleCC(Number(d.vehiclecc) || 0);
      setSchemesLess(Number(d.sp_787) || 0);
      setSubTotal(Number(d.sp_788) || 0);
      setTcs(Number(d.sp_849) || 0);
      setPriceProtection(d.sp_789 || "");
      setPackagePrice(Number(d.sp_752) || 0);
      // ================= STEP 3 =================
      setInsuranceType(d.sp_790 || "InHouse");
      setinsurancecompany(d.sp_911 || "");
      setInsuranceAmount(Number(d.sp_827) || 0);
      setAddEP(toBool(d.sp_912));
      setAddRTI(toBool(d.sp_913));
      setAddCM(toBool(d.sp_914));
      setAddPB(toBool(d.sp_915));
      setAddKP(toBool(d.sp_916));
      setAddZD(toBool(d.sp_917));
      setAddNilDep(Number(d.sp_922) > 0);
      setAddRSA(Number(d.sp_923) > 0);
      setAddEmiCover(Number(d.sp_924) > 0);
      setAddTyreCover(Number(d.sp_925) > 0);
      setAddLossIncome(Number(d.sp_926) > 0);
      setAddConsumables(Number(d.sp_927) > 0);
      setAddTowing(Number(d.sp_928) > 0);
      setAddEmergency(Number(d.sp_929) > 0);
      setAddChargerProtection(Number(d.sp_930) > 0);
      setAddBatteryCover(Number(d.sp_931) > 0);
      setAddDailyAllowance(Number(d.sp_921) > 0);
      setInsuranceMaster({
        idv: Number(d.sp_799) || 0,
        insurance_per: Number(d.sp_801) || 0,
        discount_per: Number(d.sp_803) || 0,
        zd_per: Number(d.sp_808) || 0,
        ep_per: Number(d.sp_791) || 0,
        kp_per: Number(d.sp_810) || 0,
        rti_per: Number(d.sp_792) || 0,
        cm_per: Number(d.sp_793) || 0,
        pb_per: Number(d.sp_809) || 0,
        pa_cover: Number(d.sp_807) || 0,
        third_party: Number(d.sp_806) || 0,
        paid_driver: Number(d.sp_811) || 0,
        nil_dep: Number(d.sp_922) || 0,
        rsa: Number(d.sp_923) || 0,
        emi_cover: Number(d.sp_924) || 0,
        loss_income: Number(d.sp_926) || 0,
        towing: Number(d.sp_928) || 0,
        battery_cover: Number(d.sp_931) || 0,
        tyre_cover: Number(d.sp_925) || 0,
        emergency_exp: Number(d.sp_929) || 0,
        daily_allow: Number(d.sp_921) || 0,
        consumables: Number(d.sp_927) || 0,
        charger_protection: Number(d.sp_930) || 0,
        gst: Number(d.sp_813) || 0,
      });
      // 🔥 RTO
      setRtoType(d.sp_828 || "");
      setRtoAmount(Number(d.sp_838) || 0);
      // saved as 1/0, UI expects "one" or "more"
      setVehicleOwnStatus(toBool(d.sp_855) ? "one" : "more");
      setRtoTemporary(d.sp_883 || "");
      setMunicipalTax(toBool(d.municipalTax ?? d.sp_municipalTax));
      setMunicipalAmount(
        Number(d.municipalAmount ?? d.sp_municipalAmount) || 0,
      );
      setRtoFields((prev) => ({
        ...prev,
        amount: Number(d.sp_838) || 0,
        rtoRate: Number(d.sp_830) || prev.rtoRate || 0,
        rtoTaxSurcharge: Number(d.sp_831) || prev.rtoTaxSurcharge || 0,
        greenTax: Number(d.sp_832) || prev.greenTax || 0,
        regFee: Number(d.sp_833) || prev.regFee || 0,
        hpn: Number(d.sp_834) || prev.hpn || 0,
        duplicate: Number(d.sp_835) || prev.duplicate || 0,
        smartCard: Number(d.sp_836) || prev.smartCard || 0,
        other: Number(d.sp_837) || prev.other || 0,
        scrapage: toBool(d.sp_936),
        scrapageAmount: Number(d.sp_936) || 0,
      }));
      // 🔥 TRC
      setTrcType(d.sp_907 || "");
      setTrcAmount(Number(d.sp_840) || 0);
      // 🔥 OPTIONAL EXTRA (if used in UI)
      setTrcSpecificNo(Number(d.sp_858) || 0);
      setTrcSpecificAmount(Number(d.sp_868) || 0);
      // ================= STEP 4 (ACCESSORIES) =================
      try {
        const p4Res = await apiFetch(
          "/api/booking/edit-p4",
          { method: "POST", body: JSON.stringify({ sp_732: id }) },
        );
        const p4Data = await p4Res.json();
        console.log("EDIT P4 RESPONSE =>", p4Data);
        if (p4Data.err === "0") {
          const p4 = p4Data.data || {};
          const p4Grid = p4Data.grid || [];
          console.log("P4 MAIN DATA =>", p4);
          console.log("P4 GRID =>", p4Grid);
          setSp841(p4.pkg_package || "");
          setSp842(p4.pkg_amt || "");
          setSp844(p4.pkg_discamt || "");
          setSp845(p4.pkg_totalamt || "");
          setSp846(p4.oth_pkg_tbamt || "");
          setAccAmount(Number(p4.pkg_amt) || 0);
          setAccDiscount(Number(p4.pkg_discamt) || 0);
          setAccTotalAmount(Number(p4.pkg_totalamt) || 0);
          setAccFinalTotal(Number(p4.oth_pkg_tbamt) || 0);
          if (model || d.sp_749) {
            await loadPackageList(model || d.sp_749);
          }
          setAccPackage(p4.pkg_package || "");
          setAccOtherGrid(
            p4Grid.map((row, idx) => ({
              id: row.id || idx + 1,
              category: row.category || "",
              partName: row.partName || "",
              partNo: row.partNo || row.partno || "",
              mrp: Number(row.mrp || 0),
              qty: Number(row.qty || 1),
              total: Number(row.total || 0),
            })),
          );
        }
      } catch (p4Err) {
        console.error("STEP 4 EDIT LOAD ERROR:", p4Err);
      }
      // ================= SCHEME =================
      const schemeRes = await apiFetch(
        "/api/booking/edit-scheme",
        { method: "POST", body: JSON.stringify({ sp_732: id }) },
      );
      const schemeResData = await schemeRes.json();
      const schemeList =
        schemeResData?.list ||
        schemeResData?.data?.list ||
        schemeResData?.result?.list ||
        [];
      setSchemeGrid(
        schemeList.map((item, idx) => ({
          // keep flexible for backend key casing/aliases
          schemeType:
            item.Scheme_Type ?? item.schemeType ?? item.scheme_type ?? "",
          schemeName:
            item.Scheme_Name ?? item.schemeName ?? item.scheme_name ?? "",
          schemeAmount: Number(
            item.Scheme_Amount ?? item.schemeAmount ?? item.scheme_amount ?? 0,
          ),
          schemeId:
            item.Scheme_Id ?? item.schemeId ?? item.scheme_id ?? idx + 1,
          id: item.Scheme_Id ?? item.schemeId ?? item.scheme_id ?? idx + 1,
        })),
      );
      // ================= STEP 5 =================
      setWarrantyType(d.sp_847 || "");
      setWarrantyAmount(Number(d.sp_848) || 0);
      setAmcType(d.sp_862 || "");
      setAmcAmount(Number(d.sp_863) || 0);
      setRoadSide(Number(d.sp_864) || 0);
      setLogistics(toBool(d.sp_850));
      setLogisticsAmount(Number(d.sp_851) || 0);
      setFastTag(toBool(d.sp_852));
      setFastTagAmount(Number(d.sp_853) || 600);
      setNitrogen(toBool(d.sp_854));
      setNitrogenAmount(Number(d.sp_856) || 0);
      setExchangeAmount(Number(d.sp_920) || 0);
      // load warranty & AMC lists so dropdowns can match saved values
      if (d.sp_750 && d.sp_737) {
        try {
          await getWarranty(d.sp_750, formatDate(d.sp_737));
        } catch {}
        try {
          await getAMC(d.sp_750, formatDate(d.sp_737));
        } catch {}
      }
      try {
        const p5Res = await apiFetch(
          "/api/booking/edit-p5-grid",
          { method: "POST", body: JSON.stringify({ sp_732: id }) },
        );
        const p5Data = await p5Res.json();
        if (p5Data.err === "0") {
          const p5Grid = p5Data.grid || [];
          const otherRes = await apiFetch(
            "/api/booking/other",
            { method: "POST" },
          );
          const otherResData = await otherRes.json();
          const otherListData = (otherResData?.result?.list || []).map(
            (item) => ({
              value: item.data,
              label: item.value,
            }),
          );
          setOtherList(otherListData);
          setStep5OtherGrid(
            p5Grid.map((row, idx) => {
              const matched = otherListData.find((o) => o.value === row.value);
              return {
                id: idx + 1,
                value: row.value || "",
                type: matched?.label || row.value || "",
                amount: Number(row.amount || 0),
              };
            }),
          );
        }
      } catch (p5Err) {
        console.error("STEP 5 GRID LOAD ERROR:", p5Err);
      }
      // ================= STEP 6 =================
      setCustRemark1(d.sp_753 || "");
      setCustRemark2(d.sp_754 || "");
      setCustRemark3(d.sp_755 || "");
      // ================= FINAL =================
      sessionStorage.setItem("docket_unqid", d.sp_732);
      setMode("EDIT");
    } catch (err) {
      console.error("EDIT ERROR:", err);
    }
  };
  // ✅ BOOKING DOCKET UPDATE BUTTON WORKING FOR STEP-1
  const handleUpdate = async () => {
    try {
      const docketUnqid = sessionStorage.getItem("docket_unqid");
      if (!docketUnqid) {
        alert("Docket ID missing ❌");
        return false;
      }
      const payload = {
        sp_905: docketUnqid,
        sp_733: userId,
        sp_734: ipAddress,
        sp_735: serverIp,
        sp_737: docketDate || new Date().toISOString().slice(0, 10),
        sp_738: DocketNo,
        sp_739: Salutation,
        sp_740: Name,
        sp_759: PrintName,
        sp_879: FatherName,
        sp_741: Address,
        sp_742: City,
        sp_743: Area,
        sp_859: State,
        sp_744: Email,
        sp_745: MobileNo,
        sp_769: ContactNo,
        sp_768: Zipcode,
        sp_746: Aadhaar,
        sp_766: BirthDate || "1900-01-01",
        sp_767: AnniversaryDate || "1900-01-01",
        sp_871: NomineeName,
        sp_872: NomineeAge,
        sp_873: NomineeRelation,
        sp_874: NomineeMobile,
        sp_747: PanCard,
        sp_748: GSTIN,
        sp_861: Dockettype,
        sp_860: Branch,
        sp_909: Enquiryno || "0",
        sp_935: BookingDMSId,
        sp_770: aadhaarFrontPath,
        sp_869: aadhaarBackPath,
        sp_771: panPath,
        sp_897: gstPath,
        sp_934: commitmentPath,
      };
      console.log("UPDATE PAYLOAD =>", payload);
      const res = await apiFetch(
        "/api/booking/update-docket-p1",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await res.json();
      console.log("UPDATE RESPONSE =>", data);
      if (Number(data.err || 0) !== 0) {
        alert("Updated Successfully ✅");
        console.log("UPDATE SUCCESSFUL! Redirecting to step 2...");
        setTimeout(() => {
          setStep(2);
          window.scrollTo(0, 0);
        }, 100);
        return true;
      } else {
        alert(data.msg || "Update failed");
        return false;
      }
    } catch (err) {
      console.error("UPDATE ERROR =>", err.response?.data || err.message);
      alert("Server error ❌");
      return false;
    }
  };
  // ✅ BOOKING DOCKET APPROVE BUTTON WORKING
  const handleApprove = async () => {
    try {
      const docketUnqid = sessionStorage.getItem("docket_unqid");
      if (!docketUnqid) {
        alert("No docket found");
        return;
      }
      const res = await apiFetch(
        "/api/booking/approve",
        { method: "POST", body: JSON.stringify({ sp_732: docketUnqid, sp_733: userId, sp_734: ipAddress }) },
      );
      const data = await res.json();
      if (data.err === "0") {
        alert("Approved Successfully ✅");
        navigate("/BookingDocketGrid");
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error("APPROVE ERROR:", err);
      alert("Approval failed");
    }
  };
  // ✅ BOOKING DOCKET VIEW BUTTON WORKING
  const loadViewData = async (id) => {
    try {
      setMode("VIEW");
      const res = await apiFetch("/api/booking/view", {
        method: "POST",
        body: JSON.stringify({ sp_732: id }),
      });
      const resData = await res.json();
      if (resData.err !== "0") {
        alert("Failed to load");
        return;
      }
      const d = resData.data;
      console.log("FULL EDIT DATA =>", d);
      const formatDate = (val) => {
        if (!val) return "";
        const parts = val.split("-");
        if (parts.length !== 3) return "";
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      };
      const toBool = (v) => {
        if (v === true) return true;
        if (v === false) return false;
        if (v === 1 || v === "1") return true;
        if (v === 0 || v === "0") return false;
        if (typeof v === "string") {
          const s = v.trim().toLowerCase();
          if (s === "true" || s === "yes" || s === "y") return true;
          if (s === "false" || s === "no" || s === "n") return false;
        }
        return Boolean(Number(v));
      };
      // ================= STEP 1 (FIXED MAPPING) =================
      setEnquiryno(d.sp_909 || "");
      setDocketNo(d.sp_738 || "");
      setDocketDate(formatDate(d.sp_737));
      setDockettype(d.sp_861 || "");
      setBranch(d.sp_860 || "");
      setSalutation(d.sp_739 || "");
      setName(d.sp_740 || "");
      setPrintName(d.sp_759 || "");
      setFatherName(d.sp_879 || "");
      setAddress(d.sp_741 || "");
      setEmail(d.sp_744 || "");
      setStatus(d.sp_884 || d.status || "");
      if (!StateList?.length) {
        try {
          await loadStateList();
        } catch {}
      }
      const rawState = String(d.sp_859 || "");
      const resolvedState =
        StateList.find((o) => o.value === rawState)?.value ||
        StateList.find(
          (o) => (o.label || "").toLowerCase() === rawState.toLowerCase(),
        )?.value ||
        rawState;
      const editState = resolvedState;
      const editCity = String(d.sp_742 || "");
      const editArea = String(d.sp_743 || "");
      const editZip = String(d.sp_768 || "");
      setState(editState);
      try {
        if (editState) await loadCityList(editState);
      } catch {}
      setCity(editCity);
      try {
        if (editCity) await loadAreaList(editCity);
      } catch {}
      setArea(editArea);
      try {
        if (editArea) {
          await loadZipCode(editArea);
          setZipAutoLoaded(true);
        }
      } catch {}
      setZipcode(editZip);
      setMobileNo(d.sp_745 || "");
      setContactNo(d.sp_769 || "");
      setBirthDate(formatDate(d.sp_766));
      setAnniversaryDate(formatDate(d.sp_767));
      setNomineeName(d.sp_871 || "");
      setNomineeAge(d.sp_872 || "");
      setNomineeRelation(d.sp_873 || "");
      setNomineeMobile(d.sp_874 || "");
      setAadhaar(d.sp_746 || "");
      setPanCard(d.sp_747 || "");
      setGSTIN(d.sp_748 || "");
      setBookingDMSId(d.sp_935 || d.booking_dms_id || d.bookingDmsId || "");
      setAadhaarFrontPath(d.sp_770 || "");
      setAadhaarBackPath(d.sp_869 || "");
      setPanPath(d.sp_771 || "");
      setGstPath(d.sp_897 || "");
      setCommitmentPath(d.sp_934 || "");
      // ================= STEP 2 =================
      setSaleConsultant(d.sp_756 || "");
      setTeamLeader(d.sp_757 || "");
      setManager(d.sp_758 || "");
      setFuel(d.sp_762 || "");
      setModel(d.sp_749 || "");
      if (d.sp_749) {
        await loadVariantList(d.sp_749);
      }
      setVariant(d.sp_750 || "");
      if (d.sp_750) {
        await loadColorList(d.sp_750);
      }
      setColor(d.sp_751 || "");
      setManufacturingYear(d.sp_799 || "");
      setDeliveryDate(formatDate(d.sp_760));
      setSourceBooking(d.sp_765 || "");
      setSpecificCode(d.sp_908 || "");
      setFinanceType(d.sp_772 || "");
      setCompanyAuthorised(d.sp_773 || "");
      setHpn(d.sp_774 || "");
      setHpnBranch(d.sp_775 || "");
      setLoanAmount(d.sp_777 || "");
      setNetDisbursedAmount(d.sp_776 || "");
      setSpecialDiscount(d.sp_785 || "");
      setExShowroom(Number(d.sp_786) || 0);
      setVehicleCC(Number(d.vehiclecc) || 0);
      setSchemesLess(Number(d.sp_787) || 0);
      setSubTotal(Number(d.sp_788) || 0);
      setTcs(Number(d.sp_849) || 0);
      setPriceProtection(d.sp_789 || "");
      setPackagePrice(Number(d.sp_752) || 0);
      // ================= STEP 3 =================
      setInsuranceType(d.sp_790 || "InHouse");
      setinsurancecompany(d.sp_911 || "");
      setInsuranceAmount(Number(d.sp_827) || 0);
      setAddEP(toBool(d.sp_912));
      setAddRTI(toBool(d.sp_913));
      setAddCM(toBool(d.sp_914));
      setAddPB(toBool(d.sp_915));
      setAddKP(toBool(d.sp_916));
      setAddZD(toBool(d.sp_917));
      setAddNilDep(Number(d.sp_922) > 0);
      setAddRSA(Number(d.sp_923) > 0);
      setAddEmiCover(Number(d.sp_924) > 0);
      setAddTyreCover(Number(d.sp_925) > 0);
      setAddLossIncome(Number(d.sp_926) > 0);
      setAddConsumables(Number(d.sp_927) > 0);
      setAddTowing(Number(d.sp_928) > 0);
      setAddEmergency(Number(d.sp_929) > 0);
      setAddChargerProtection(Number(d.sp_930) > 0);
      setAddBatteryCover(Number(d.sp_931) > 0);
      setAddDailyAllowance(Number(d.sp_921) > 0);
      setInsuranceMaster({
        idv: Number(d.sp_799) || 0,
        insurance_per: Number(d.sp_801) || 0,
        discount_per: Number(d.sp_803) || 0,
        zd_per: Number(d.sp_808) || 0,
        ep_per: Number(d.sp_791) || 0,
        kp_per: Number(d.sp_810) || 0,
        rti_per: Number(d.sp_792) || 0,
        cm_per: Number(d.sp_793) || 0,
        pb_per: Number(d.sp_809) || 0,
        pa_cover: Number(d.sp_807) || 0,
        third_party: Number(d.sp_806) || 0,
        paid_driver: Number(d.sp_811) || 0,
        nil_dep: Number(d.sp_922) || 0,
        rsa: Number(d.sp_923) || 0,
        emi_cover: Number(d.sp_924) || 0,
        loss_income: Number(d.sp_926) || 0,
        towing: Number(d.sp_928) || 0,
        battery_cover: Number(d.sp_931) || 0,
        tyre_cover: Number(d.sp_925) || 0,
        emergency_exp: Number(d.sp_929) || 0,
        daily_allow: Number(d.sp_921) || 0,
        consumables: Number(d.sp_927) || 0,
        charger_protection: Number(d.sp_930) || 0,
        gst: Number(d.sp_813) || 0,
      });
      // 🔥 RTO
      setRtoType(d.sp_828 || "");
      setRtoAmount(Number(d.sp_838) || 0);
      // saved as 1/0, UI expects "one" or "more"
      setVehicleOwnStatus(toBool(d.sp_855) ? "one" : "more");
      setRtoTemporary(d.sp_883 || "");
      setMunicipalTax(toBool(d.municipalTax ?? d.sp_municipalTax));
      setMunicipalAmount(
        Number(d.municipalAmount ?? d.sp_municipalAmount) || 0,
      );
      setRtoFields((prev) => ({
        ...prev,
        amount: Number(d.sp_838) || 0,
        rtoRate: Number(d.sp_830) || prev.rtoRate || 0,
        rtoTaxSurcharge: Number(d.sp_831) || prev.rtoTaxSurcharge || 0,
        greenTax: Number(d.sp_832) || prev.greenTax || 0,
        regFee: Number(d.sp_833) || prev.regFee || 0,
        hpn: Number(d.sp_834) || prev.hpn || 0,
        duplicate: Number(d.sp_835) || prev.duplicate || 0,
        smartCard: Number(d.sp_836) || prev.smartCard || 0,
        other: Number(d.sp_837) || prev.other || 0,
        scrapage: toBool(d.sp_936),
        scrapageAmount: Number(d.sp_936) || 0,
      }));
      // 🔥 TRC
      setTrcType(d.sp_907 || "");
      setTrcAmount(Number(d.sp_840) || 0);
      // 🔥 OPTIONAL EXTRA (if used in UI)
      setTrcSpecificNo(Number(d.sp_858) || 0);
      setTrcSpecificAmount(Number(d.sp_868) || 0);
      // ================= STEP 4 (ACCESSORIES) =================
      try {
        const p4Res = await apiFetch(
          "/api/booking/view-p4",
          { method: "POST", body: JSON.stringify({ sp_732: id }) },
        );
        const p4Data = await p4Res.json();
        console.log("EDIT P4 RESPONSE =>", p4Data);
        if (p4Data.err === "0") {
          const p4 = p4Data.data || {};
          const p4Grid = p4Data.grid || [];
          console.log("P4 MAIN DATA =>", p4);
          console.log("P4 GRID =>", p4Grid);
          setSp841(p4.pkg_package || "");
          setSp842(p4.pkg_amt || "");
          setSp844(p4.pkg_discamt || "");
          setSp845(p4.pkg_totalamt || "");
          setSp846(p4.oth_pkg_tbamt || "");
          setAccAmount(Number(p4.pkg_amt) || 0);
          setAccDiscount(Number(p4.pkg_discamt) || 0);
          setAccTotalAmount(Number(p4.pkg_totalamt) || 0);
          setAccFinalTotal(Number(p4.oth_pkg_tbamt) || 0);
          if (model || d.sp_749) {
            await loadPackageList(model || d.sp_749);
          }
          setAccPackage(p4.pkg_package || "");
          setAccOtherGrid(
            p4Grid.map((row, idx) => ({
              id: row.id || idx + 1,
              category: row.category || "",
              partName: row.partName || "",
              partNo: row.partNo || row.partno || "",
              mrp: Number(row.mrp || 0),
              qty: Number(row.qty || 1),
              total: Number(row.total || 0),
            })),
          );
        }
      } catch (p4Err) {
        console.error("STEP 4 EDIT LOAD ERROR:", p4Err);
      }
      // ================= SCHEME =================
      const schemeRes = await apiFetch(
        "/api/booking/view-scheme",
        { method: "POST", body: JSON.stringify({ sp_732: id }) },
      );
      const schemeResData = await schemeRes.json();
      const schemeList =
        schemeResData?.list ||
        schemeResData?.data?.list ||
        schemeResData?.result?.list ||
        [];
      setSchemeGrid(
        schemeList.map((item, idx) => ({
          schemeType:
            item.Scheme_Type ?? item.schemeType ?? item.scheme_type ?? "",
          schemeName:
            item.Scheme_Name ?? item.schemeName ?? item.scheme_name ?? "",
          schemeAmount: Number(
            item.Scheme_Amount ?? item.schemeAmount ?? item.scheme_amount ?? 0,
          ),
          schemeId:
            item.Scheme_Id ?? item.schemeId ?? item.scheme_id ?? idx + 1,
          id: item.Scheme_Id ?? item.schemeId ?? item.scheme_id ?? idx + 1,
        })),
      );
      // ================= STEP 5 =================
      setWarrantyType(d.sp_847 || "");
      setWarrantyAmount(Number(d.sp_848) || 0);
      setAmcType(d.sp_862 || "");
      setAmcAmount(Number(d.sp_863) || 0);
      setRoadSide(Number(d.sp_864) || 0);
      setLogistics(toBool(d.sp_850));
      setLogisticsAmount(Number(d.sp_851) || 0);
      setFastTag(toBool(d.sp_852));
      setFastTagAmount(Number(d.sp_853) || 600);
      setNitrogen(toBool(d.sp_854));
      setNitrogenAmount(Number(d.sp_856) || 0);
      setExchangeAmount(Number(d.sp_920) || 0);
      // load warranty & AMC lists so dropdowns can match saved values
      if (d.sp_750 && d.sp_737) {
        try {
          await getWarranty(d.sp_750, formatDate(d.sp_737));
        } catch {}
        try {
          await getAMC(d.sp_750, formatDate(d.sp_737));
        } catch {}
      }
      // load step 5 other grid
      try {
        const p5Res = await apiFetch(
          "/api/booking/edit-p5-grid",
          { method: "POST", body: JSON.stringify({ sp_732: id }) },
        );
        const p5Data = await p5Res.json();
        if (p5Data.err === "0") {
          const p5Grid = p5Data.grid || [];
          const otherRes = await apiFetch(
            "/api/booking/other",
            { method: "POST" },
          );
          const otherResData = await otherRes.json();
          const otherListData = (otherResData?.result?.list || []).map(
            (item) => ({
              value: item.data,
              label: item.value,
            }),
          );
          setOtherList(otherListData);
          setStep5OtherGrid(
            p5Grid.map((row, idx) => {
              const matched = otherListData.find((o) => o.value === row.value);
              return {
                id: idx + 1,
                value: row.value || "",
                type: matched?.label || row.value || "",
                amount: Number(row.amount || 0),
              };
            }),
          );
        }
      } catch (p5Err) {
        console.error("STEP 5 GRID LOAD ERROR:", p5Err);
      }
      // ================= STEP 6 =================
      setCustRemark1(d.sp_753 || "");
      setCustRemark2(d.sp_754 || "");
      setCustRemark3(d.sp_755 || "");
      // ================= FINAL =================
      sessionStorage.setItem("docket_unqid", d.sp_732);
      setMode("VIEW");
    } catch (err) {
      console.error("VIEW ERROR:", err);
    }
  };
  console.log("MODE:", mode, "STATUS:", status);

  return (
    <Layout>
      <div className="page-container-imd">
        <div className="container-imd">
          <div className="header-imd">Booking Docket</div>
          {step === 1 && (
            <>
              <div className="subheader-imd">Customer Details</div>
              {/* INNER BORDERED CONTAINER */}
              <div className="inner-frame-imd">
                {/* SCROLLABLE FORM */}
                <div className="form-scroll-imd">
                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Enquiry No.</label>
                      <Select
                        classNamePrefix="rs"
                        options={EnquirynoList}
                        value={
                          EnquirynoList.find((o) => o.label === Enquiryno) ||
                          null
                        }
                        onChange={(selected) => {
                          const enquiryId = selected?.value || "";
                          const enquiryNo = selected?.label || "";
                          setEnquiryno(enquiryNo);
                          if (enquiryId) {
                            loadEnquiryData(enquiryId);
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            return inputValue.replace(/[^0-9]/g, "");
                          }
                          return inputValue;
                        }}
                        styles={customStyles}
                        placeholder="Select Enquiry No"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Docket No</label>
                      <input
                        type="number"
                        className="input-imd"
                        value={DocketNo}
                        readOnly
                        style={{ background: "#f2f2f2", fontWeight: "600" }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Date:</label>
                      <input
                        type="date"
                        className="input-imd"
                        value={docketDate}
                        onChange={(e) => setDocketDate(e.target.value)}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Docket Type.</label>
                      <Select
                        classNamePrefix="rs"
                        options={DocketTypeOptions}
                        value={
                          DocketTypeOptions.find(
                            (o) => o.value === Dockettype,
                          ) || null
                        }
                        onChange={(selected) =>
                          setDockettype(selected?.value || "")
                        }
                        styles={customStyles}
                        placeholder="Select Docket Type"
                        isSearchable={false}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Branch.</label>
                      <Select
                        classNamePrefix="rs"
                        options={BranchList}
                        value={
                          BranchList.find((o) => o.value === Branch) || null
                        }
                        onChange={(selected) =>
                          setBranch(selected?.value || "")
                        }
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            return inputValue.replace(/[^a-zA-Z ]/g, "");
                          }
                          return inputValue;
                        }}
                        styles={customStyles}
                        placeholder="Select Branch"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Salutation</label>
                      <div
                        style={{
                          border: errors.Salutation ? "2px solid red" : "none",
                          borderRadius: "8px",
                        }}
                      >
                        <Select
                          classNamePrefix="rs"
                          options={SalutationOptions}
                          value={
                            SalutationOptions.find(
                              (o) => o.value === Salutation,
                            ) || null
                          }
                          onChange={(selected) =>
                            setSalutation(selected?.value || "")
                          }
                          styles={customStyles}
                          placeholder="Select Salutation"
                          isSearchable={false}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      </div>
                    </div>
                    <div className="form-item-imd">
                      <label style={{ visibility: "hidden" }}>Name</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={Name}
                        placeholder="Enter Name"
                        onChange={(e) =>
                          setName(allowAlphabets(e.target.value))
                        }
                        style={{
                          border: errors.Name
                            ? "2px solid red"
                            : "1px solid #d8d8d8",
                        }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Print Name</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={PrintName}
                        placeholder="Enter Print Name"
                        onChange={(e) =>
                          setPrintName(allowAlphabets(e.target.value))
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Father's/Husband's Name</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={FatherName}
                        placeholder="Enter Father's/Husband's Name"
                        onChange={(e) =>
                          setFatherName(allowAlphabets(e.target.value))
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Address</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={Address}
                        placeholder="Enter Address"
                        onChange={(e) => setAddress(e.target.value)}
                        style={{
                          border: errors.Address
                            ? "2px solid red"
                            : "1px solid #d8d8d8",
                        }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Email</label>
                      <input
                        type="email"
                        className="input-imd"
                        value={Email}
                        placeholder="Enter Email"
                        onChange={(e) => {
                          const val = e.target.value;
                          setEmail(val);
                          setEmailError(val !== "" && !validateEmail(val));
                        }}
                        style={{
                          border: EmailError
                            ? "2px solid red"
                            : "1px solid #cfcfcf",
                        }}
                      />
                      {EmailError && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          Please enter a valid email address
                        </span>
                      )}
                    </div>
                    <div className="form-item-imd">
                      <label>State</label>
                      <Select
                        classNamePrefix="rs"
                        options={StateList}
                        value={StateList.find((o) => o.value === State) || null}
                        onChange={(selected) => setState(selected?.value || "")}
                        styles={customStyles}
                        placeholder="Select State"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>City</label>
                      <div className="city-wrapper">
                        <div className="city-select">
                          <Select
                            classNamePrefix="rs"
                            options={CityList}
                            getOptionLabel={(o) => o.label}
                            getOptionValue={(o) => o.value}
                            value={
                              CityList.find((c) => c.value === City) || null
                            }
                            onChange={(selected) => {
                              setCity(selected?.value || "");
                              setArea("");
                              setAreaList([]);
                            }}
                            placeholder="Select City"
                            styles={customStyles}
                            isSearchable
                            isDisabled={!State}
                          />
                        </div>
                        <button
                          type="button"
                          className="city-add-btn"
                          onClick={() => {
                            setNewCityStateName(
                              StateList.find((s) => s.value === State)?.label ||
                                "",
                            );
                            setShowCityModal(true);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="form-item-imd">
                      <label>Area</label>
                      <div className="city-wrapper">
                        <div className="city-select">
                          <Select
                            classNamePrefix="rs"
                            options={AreaList}
                            value={
                              AreaList.find((a) => a.value === Area) || null
                            }
                            onChange={(selected) =>
                              setArea(selected?.value || "")
                            }
                            placeholder="Select Area"
                            styles={customStyles}
                            isSearchable
                            isDisabled={!City}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </div>
                        <button
                          type="button"
                          className="city-add-btn"
                          onClick={() => {
                            setNewAreaCityName(
                              CityList.find((c) => c.value === City)?.label ||
                                "",
                            );
                            setShowAreaModal(true);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="form-item-imd">
                      <label>Zip Code</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={Zipcode}
                        maxLength="6"
                        onChange={(e) => {
                          setZipAutoLoaded(false); // user is editing now
                          setZipcode(e.target.value.replace(/[^0-9]/g, ""));
                        }}
                        placeholder="Enter Zip Code"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Mobile No</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={MobileNo}
                        placeholder="Enter 10 digit mobile number"
                        maxLength="10"
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          setMobileNo(val);
                          setMobileError(val.length !== 10);
                        }}
                        style={{
                          border: MobileError
                            ? "2px solid red"
                            : "1px solid #cfcfcf",
                        }}
                      />
                      {MobileError && MobileNo.length > 0 && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        ></span>
                      )}
                    </div>
                    <div className="form-item-imd">
                      <label>Contact No</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={ContactNo}
                        placeholder="Enter contact number"
                        onChange={(e) =>
                          setContactNo(e.target.value.replace(/[^0-9]/g, ""))
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Birth Date</label>
                      <input
                        type="date"
                        className="input-imd"
                        value={BirthDate}
                        onChange={(e) => setBirthDate(e.target.value)}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Anniversary Date</label>
                      <input
                        type="date"
                        className="input-imd"
                        value={AnniversaryDate}
                        onChange={(e) => setAnniversaryDate(e.target.value)}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Nominee Name</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={NomineeName}
                        placeholder="Enter Nominee Name"
                        onChange={(e) =>
                          setNomineeName(allowAlphabets(e.target.value))
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Nominee Age</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={NomineeAge}
                        placeholder="Enter Nominee Age"
                        maxLength="3"
                        onChange={(e) =>
                          setNomineeAge(e.target.value.replace(/[^0-9]/g, ""))
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Relationship</label>
                      <Select
                        classNamePrefix="rs"
                        options={RelationshipOptions}
                        value={
                          RelationshipOptions.find(
                            (o) => o.value === NomineeRelation,
                          ) || null
                        }
                        onChange={(selected) =>
                          setNomineeRelation(selected?.value || "")
                        }
                        styles={customStyles}
                        placeholder="Choose Relationship"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Nominee Mobile No</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={NomineeMobile}
                        placeholder="Enter 10 digit mobile number"
                        maxLength="10"
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          setNomineeMobile(val);
                          setNomineeMobileError(val.length !== 10);
                        }}
                        style={{
                          border: NomineeMobileError
                            ? "2px solid red"
                            : "1px solid #cfcfcf",
                        }}
                      />
                      {NomineeMobileError && NomineeMobile.length > 0 && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        >
                          Please enter valid 10 digit mobile number
                        </span>
                      )}
                    </div>
                    <div className="form-item-imd">
                      <label>Aadhaar Card No</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={Aadhaar}
                        placeholder="Enter 12 digit Aadhaar number"
                        maxLength="12"
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          setAadhaar(val);
                          setAadhaarError(val.length !== 12);
                        }}
                        style={{
                          border: AadhaarError
                            ? "2px solid red"
                            : "1px solid #cfcfcf",
                        }}
                      />
                      {AadhaarError && Aadhaar.length > 0 && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          Aadhaar must be 12 digits
                        </span>
                      )}
                    </div>
                    <div className="form-item-imd">
                      <label>PAN Card No</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={PanCard}
                        placeholder="Enter PAN Card Number"
                        maxLength="10"
                        style={{
                          border: errors.Pan
                            ? "2px solid red"
                            : "1px solid #d8d8d8",
                        }}
                        onChange={(e) =>
                          setPanCard(
                            allowAlphaNumeric(e.target.value).toUpperCase(),
                          )
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>GSTIN No</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={GSTIN}
                        placeholder="Enter GSTIN Number"
                        maxLength="15"
                        onChange={(e) =>
                          setGSTIN(
                            e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z0-9]/g, ""),
                          )
                        }
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Booking ID of DMS</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={BookingDMSId}
                        placeholder="Enter Booking ID"
                        onChange={(e) => setBookingDMSId(e.target.value)}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Aadhaar Card (Front)</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="input-imd"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setAadharFrontUpload(file);

                          if (file) {
                            setAadharFrontPreview(URL.createObjectURL(file));
                          }
                        }}
                      />
                      {aadharFrontPreview && (
                        <div className="aadhaar-preview">
                          <img
                            src={aadharFrontPreview}
                            alt="Aadhaar Front Preview"
                          />
                        </div>
                      )}
                      <button
                        type="button"
                        className="btn-upload"
                        onClick={async () => {
                          const path = await uploadFile(
                            aadharFrontUpload,
                            "aadhaar",
                            "front",
                          );
                          setAadhaarFrontPath(path);
                          console.log("AADHAAR FRONT PATH:", path);
                          alert("Aadhaar Front uploaded successfully");
                        }}
                      >
                        Upload Aadhaar Front
                      </button>
                    </div>
                    <div className="form-item-imd">
                      <label>Aadhaar Card (Back)</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="input-imd"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setAadharBackUpload(file);

                          if (file) {
                            setAadharBackPreview(URL.createObjectURL(file));
                          }
                        }}
                      />
                      {aadharBackPreview && (
                        <div className="aadhaar-preview">
                          <img
                            src={aadharBackPreview}
                            alt="Aadhaar Back Preview"
                          />
                        </div>
                      )}
                      <button
                        type="button"
                        className="btn-upload"
                        onClick={async () => {
                          const path = await uploadFile(
                            aadharBackUpload,
                            "aadhaar",
                            "back",
                          );
                          setAadhaarBackPath(path);

                          alert("Aadhaar Back uploaded successfully");
                        }}
                      >
                        Upload Aadhaar Back
                      </button>
                    </div>
                    <div className="form-item-imd">
                      <label>PAN Card (Front)</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="input-imd"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setPanFrontUpload(file);

                          if (file) {
                            setPanFrontPreview(URL.createObjectURL(file));
                          }
                        }}
                      />
                      {panFrontPreview && (
                        <div className="aadhaar-preview">
                          <img src={panFrontPreview} alt="PAN Card Preview" />
                        </div>
                      )}
                      <button
                        type="button"
                        className="btn-upload"
                        onClick={async () => {
                          const path = await uploadFile(panFrontUpload, "pan");
                          setPanPath(path);

                          alert("PAN Card uploaded successfully");
                        }}
                      >
                        Upload PAN Card
                      </button>
                    </div>
                    <div className="form-item-imd">
                      <label>GST Certificate (PDF)</label>
                      <input
                        type="file"
                        accept="application/pdf"
                        className="input-imd"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setGstPdfUpload(file);

                          if (file) {
                            setGstPdfName(file.name);
                          }
                        }}
                      />
                      {gstPdfName && (
                        <div className="pdf-preview">📄 {gstPdfName}</div>
                      )}
                      <button
                        type="button"
                        className="btn-upload"
                        onClick={async () => {
                          const path = await uploadFile(gstPdfUpload, "gst");
                          setGstPath(path);

                          alert("GST PDF uploaded successfully");
                        }}
                      >
                        Upload GST PDF
                      </button>
                    </div>
                    <div className="form-item-imd">
                      <label>Booking Commitment Form</label>
                      <input
                        type="file"
                        accept="application/pdf,image/*"
                        className="input-imd"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setCommitmentUpload(file);

                          if (file) {
                            setCommitmentFileName(file.name);
                          }
                        }}
                      />
                      {commitmentFileName && (
                        <div className="pdf-preview">
                          📄 {commitmentFileName}
                        </div>
                      )}
                      <button
                        type="button"
                        className="btn-upload"
                        onClick={async () => {
                          const path = await uploadFile(
                            commitmentUpload,
                            "commitment",
                          );
                          setCommitmentPath(path);
                          console.log("COMMITMENT PATH:", path);
                          alert(
                            "Booking Commitment Form uploaded successfully",
                          );
                        }}
                      >
                        Upload Commitment Form
                      </button>
                    </div>
                  </div>
                </div>
                {/* ================= PACKAGE PRICE (ALL STEPS) ================= */}
                <div className="package-price-row">
                  <label style={{ fontWeight: 600 }}>Package Price:</label>
                  <input
                    type="text"
                    value={packagePrice}
                    onChange={(e) => setPackagePrice(e.target.value)}
                    className="package-price-input"
                  />
                </div>

                {/* FOOTER BUTTONS */}
                <div className="footer-actions-imd">
                  <div></div>

                  <div>
                    <button
                      className="next-btn-imd"
                      onClick={async () => {
                        let success = false;

                        // ✅ VIEW MODE → no API call
                        if (mode === "VIEW") {
                          setStep(2);
                          return;
                        }

                        // ✅ ADD MODE → INSERT
                        if (mode === "ADD") {
                          success = await handleSave();
                        }

                        // ✅ EDIT MODE → UPDATE
                        if (mode === "EDIT") {
                          success = await handleUpdate();
                        }

                        if (success) {
                          setStep(2);
                        }
                      }}
                    >
                      {mode === "ADD" ? "Next" : "Update & Next"}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <div className="subheader-imd">Vehicle Details</div>
              <div className="inner-frame-imd">
                <div className="form-scroll-imd">
                  <div className="form-grid-imd">
                    {/* ROW 1 */}
                    <div className="form-item-imd">
                      <label>Sale Consultant</label>
                      <Select
                        classNamePrefix="rs"
                        options={saleConsultantList}
                        getOptionLabel={(o) => o.label}
                        getOptionValue={(o) => o.value}
                        value={
                          saleConsultantList.find(
                            (o) => o.value === saleConsultant,
                          ) || null
                        }
                        onChange={async (selected) => {
                          const scValue = selected?.value || "";
                          setSaleConsultant(scValue);
                          if (scValue) {
                            await loadSCHierarchy(scValue);
                          }
                        }}
                        styles={customStyles}
                        placeholder="Select Sale Consultant"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Team Leader</label>
                      <input
                        className="input-imd"
                        value={teamLeader}
                        disabled
                        placeholder="Auto"
                        style={{ background: "#f2f2f2", fontWeight: 600 }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Manager</label>
                      <input
                        className="input-imd"
                        value={manager}
                        disabled
                        placeholder="Auto"
                        style={{ background: "#f2f2f2", fontWeight: 600 }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Fuel</label>
                      <Select
                        classNamePrefix="rs"
                        options={fuelList}
                        value={fuelList.find((o) => o.value === fuel) || null}
                        onChange={(s) => setFuel(s?.value || "")}
                        styles={customStyles}
                        placeholder="Select Fuel"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    {/* ROW 2 */}
                    <div className="form-item-imd">
                      <label>Model *</label>
                      <Select
                        classNamePrefix="rs"
                        options={modelList}
                        value={modelList.find((o) => o.value === model) || null}
                        onChange={(s) => {
                          setModel(s?.value || "");
                          setVariant("");
                          setVariantList([]);
                        }}
                        styles={customStyles}
                        placeholder="Select Model"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Variant *</label>
                      <Select
                        classNamePrefix="rs"
                        options={variantList}
                        value={
                          variantList.find((o) => o.value === variant) || null
                        }
                        onChange={async (s) => {
                          const v = s?.value || "";
                          setVariant(v);
                          if (v) {
                            await loadSpCode(v);

                            // LOAD WARRANTY
                            getWarranty(v, docketDate);
                            getAMC(v, docketDate);
                          }
                          setExShowroom(0);
                          setSchemesLess(0);
                          setSubTotal(0);
                          setVehicleCess(0);
                          setTcs(0);
                          setPackagePrice(0);
                        }}
                        styles={customStyles}
                        placeholder="Select"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Color *</label>
                      <Select
                        classNamePrefix="rs"
                        options={colorList}
                        value={colorList.find((o) => o.value === color) || null}
                        onChange={async (s) => {
                          const colorValue = s?.value || "";
                          setColor(colorValue);
                          if (variant && colorValue) {
                            await loadVariantDetails();
                          }
                        }}
                        styles={customStyles}
                        placeholder="Select Color"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Manufacturing Year</label>
                      <input
                        className="input-imd"
                        value={manufacturingYear}
                        disabled
                        placeholder="Auto"
                        style={{ background: "#f2f2f2", fontWeight: 600 }}
                      />
                    </div>
                    {/* ROW 3 */}
                    <div className="form-item-imd">
                      <label>Delivery Date</label>
                      <input
                        type="date"
                        className="input-imd"
                        value={deliveryDate}
                        onChange={(e) => setDeliveryDate(e.target.value)}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Source Of Booking *</label>
                      <Select
                        classNamePrefix="rs"
                        options={sourceBookingList}
                        value={
                          sourceBookingList.find(
                            (o) => o.value === sourceBooking,
                          ) || null
                        }
                        onChange={(s) => setSourceBooking(s?.value || "")}
                        styles={customStyles}
                        placeholder="Select"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Specific Code *</label>
                      <input
                        className="input-imd"
                        value={specificCode}
                        disabled
                        style={{ background: "#f2f2f2", fontWeight: 600 }}
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= FINANCE ================= */}
                  <div className="subheader-imd">Finance</div>
                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Finance Type</label>
                      <div style={{ display: "flex", gap: "14px" }}>
                        <label>
                          <input
                            type="radio"
                            checked={financeType === "InHouse"}
                            onChange={() => setFinanceType("InHouse")}
                          />{" "}
                          In House
                        </label>
                        <label>
                          <input
                            type="radio"
                            checked={financeType === "OutHouse"}
                            onChange={() => setFinanceType("OutHouse")}
                          />{" "}
                          Out House
                        </label>
                        <label>
                          <input
                            type="radio"
                            checked={financeType === "Cash"}
                            onChange={() => setFinanceType("Cash")}
                          />{" "}
                          Cash
                        </label>
                      </div>
                    </div>
                    <div className="form-item-imd">
                      <label>Company Authorised</label>
                      <div style={{ display: "flex", gap: "14px" }}>
                        <label>
                          <input
                            type="radio"
                            checked={companyAuthorised === "Yes"}
                            onChange={() => setCompanyAuthorised("Yes")}
                          />{" "}
                          Yes
                        </label>
                        <label>
                          <input
                            type="radio"
                            checked={companyAuthorised === "No"}
                            onChange={() => setCompanyAuthorised("No")}
                          />{" "}
                          No
                        </label>
                      </div>
                    </div>
                    <div className="form-item-imd">
                      <label>HPN</label>
                      <Select
                        classNamePrefix="rs"
                        options={hpnList}
                        value={hpnList.find((o) => o.value === hpn) || null}
                        onChange={(s) => setHpn(s?.value || "")}
                        styles={customStyles}
                        placeholder="Select Bank"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>HPN Branch</label>
                      <Select
                        classNamePrefix="rs"
                        options={hpnBranchList}
                        value={
                          hpnBranchList.find((o) => o.value === hpnBranch) ||
                          null
                        }
                        onChange={(s) => setHpnBranch(s?.value || "")}
                        styles={customStyles}
                        placeholder="Select Branch"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Loan Amount</label>
                      <input
                        className="input-imd"
                        value={loanAmount}
                        onChange={(e) => setLoanAmount(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Net Disbursed Amount</label>
                      <input
                        className="input-imd"
                        value={netDisbursedAmount}
                        onChange={(e) => setNetDisbursedAmount(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= SCHEME DETAILS ================= */}
                  <div className="subheader-imd">Scheme Details</div>
                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Scheme Type</label>
                      <Select
                        classNamePrefix="rs"
                        options={schemeTypeList}
                        value={
                          schemeTypeList.find((o) => o.value === schemeType) ||
                          null
                        }
                        onChange={(s) => setSchemeType(s?.value || "")}
                        styles={customStyles}
                        placeholder="Select"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Scheme Name</label>
                      <Select
                        classNamePrefix="rs"
                        options={schemeNameList}
                        value={
                          schemeNameList.find((o) => o.value === schemeName) ||
                          null
                        }
                        onChange={(s) => setSchemeName(s?.value || "")}
                        styles={customStyles}
                        placeholder="Select"
                        isSearchable
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Scheme Amount</label>
                      <input
                        className="input-imd"
                        value={schemeAmount}
                        onChange={(e) => setSchemeAmount(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                    <div
                      className="form-item-imd"
                      style={{ display: "flex", alignItems: "flex-end" }}
                    >
                      <button
                        className="next-btn-imd"
                        style={{ background: "#2fa84f" }}
                        onClick={handleAddScheme}
                      >
                        Add Scheme
                      </button>
                    </div>
                  </div>
                  {schemeGrid.length > 0 && (
                    <div
                      style={{ marginTop: "12px", border: "1px solid #8B1E3F" }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 4fr 2fr 1fr",
                          background: "#8B1E3F",
                          color: "#fff",
                          padding: "8px",
                          fontWeight: 600,
                        }}
                      >
                        <div>Scheme Type</div>
                        <div>Scheme Name</div>
                        <div>Scheme Amount</div>
                        <div>Action</div>
                      </div>
                      {schemeGrid.map((row) => (
                        <div
                          key={row.id}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 4fr 2fr 1fr",
                            padding: "8px",
                            borderTop: "1px solid #ddd",
                            alignItems: "center",
                          }}
                        >
                          <div>{row.schemeType}</div>
                          <div>{row.schemeName}</div>
                          <div>{row.schemeAmount}</div>
                          <div>
                            <button
                              style={{
                                background: "#d9534f",
                                color: "#fff",
                                border: "none",
                                padding: "4px 10px",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleDeleteScheme(row.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  <br></br>
                  {/* ================= OTHER SCHEMES DISCOUNT ================= */}
                  <div className="subheader-imd">Other Schemes Discount</div>
                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Special Discount</label>
                      <input
                        className="input-imd"
                        value={specialDiscount}
                        onChange={(e) => setSpecialDiscount(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= PRICE BREAKUP ================= */}
                  <div className="subheader-imd">Price Breakup</div>
                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Ex-Showroom</label>
                      <input
                        className="input-imd"
                        value={exShowroom}
                        style={{ background: "#f1f1f1" }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Vehicle CC</label>
                      <input
                        className="input-imd"
                        value={vehicleCC}
                        disabled
                        style={{ background: "#f1f1f1" }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Schemes Less</label>
                      <input
                        className="input-imd"
                        value={schemesLess}
                        disabled
                        style={{ background: "#f1f1f1" }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Sub Total</label>
                      <input
                        className="input-imd"
                        value={subTotal}
                        disabled
                        style={{ background: "#f1f1f1" }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>TCS</label>
                      <input
                        className="input-imd"
                        value={tcs}
                        onChange={(e) => setTcs(e.target.value)}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label style={{ visibility: "hidden" }}>
                        Price Protection
                      </label>
                      <div style={{ marginTop: "28px" }}>
                        <label>
                          <input
                            type="checkbox"
                            checked={priceProtection}
                            onChange={(e) =>
                              setPriceProtection(e.target.checked)
                            }
                          />
                          Price Protection
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ================= PACKAGE PRICE (ALL STEPS) ================= */}
                <div className="package-price-row">
                  <label style={{ fontWeight: 600 }}>Package Price:</label>
                  <input
                    type="text"
                    value={packagePrice}
                    onChange={(e) => setPackagePrice(e.target.value)}
                    className="package-price-input"
                  />
                </div>

                <div className="footer-actions-imd">
                  <button className="exit-btn-imd" onClick={() => setStep(1)}>
                    Previous
                  </button>

                  <button
                    className="next-btn-imd"
                    onClick={async () => {
                      // ✅ VIEW MODE → skip API
                      if (mode === "VIEW") {
                        setStep(3);
                        return;
                      }

                      // ✅ ADD / EDIT → call API
                      await handleSaveStep2();
                      setStep(3);
                    }}
                  >
                    {mode === "ADD" ? "Next" : "Update & Next"}
                  </button>
                </div>
              </div>
            </>
          )}
          {step === 3 && (
            <>
              <div className="section-header-left">Insurance</div>

              <div className="inner-frame-imd step-insurance">
                <div className="form-scroll-imd">
                  <div className="insurance-wrap">
                    {/* ===== LEFT : TYPE + COMPANY ===== */}
                    <div className="insurance-left">
                      <div className="insurance-section-title">
                        Insurance Type
                      </div>

                      <div className="insurance-type-box">
                        <label>
                          <input
                            type="radio"
                            name="insuranceType"
                            checked={insuranceType === "InHouse"}
                            onChange={() => setInsuranceType("InHouse")}
                          />
                          In House
                        </label>

                        <label>
                          <input
                            type="radio"
                            name="insuranceType"
                            checked={insuranceType === "OutHouse"}
                            onChange={() => setInsuranceType("OutHouse")}
                          />
                          Out House
                        </label>
                      </div>
                      {/* ===== REMARKS (Reason For Out House) ===== */}

                      {insuranceType === "OutHouse" && (
                        <>
                          <div
                            className="insurance-section-title"
                            style={{ marginTop: "16px" }}
                          >
                            Remarks (Reason For Out House)
                          </div>

                          <textarea
                            className="input-imd"
                            rows={3}
                            value={insuranceRemarks}
                            onChange={(e) =>
                              setInsuranceRemarks(e.target.value)
                            }
                            placeholder="Enter reason for out house insurance"
                            style={{ resize: "vertical" }}
                          />
                        </>
                      )}
                      <div
                        className="insurance-section-title"
                        style={{ marginTop: "16px" }}
                      >
                        Insurance Company
                      </div>

                      <Select
                        classNamePrefix="rs"
                        options={insurancecompanyList}
                        value={
                          insurancecompanyList.find(
                            (o) => o.value === insurancecompany,
                          ) || null
                        }
                        onChange={async (selected) => {
                          const val = selected?.value || "";
                          setinsurancecompany(val);

                          if (!val || !model) return;

                          try {
                            const response = await apiFetch(
                              "/api/booking/get-insurance-calculation",
                              {
                                method: "POST",
                                body: JSON.stringify({
                                  company: val,
                                  date:
                                    docketDate ||
                                    new Date().toISOString().slice(0, 10),
                                }),
                              },
                            );

                            const data = await response.json();

                            console.log("INSURANCE MASTER RAW =>", data);

                            if (data && data.length > 0) {
                              setInsuranceMaster(data[0]); // ✅ TAKE FIRST OBJECT
                            }
                          } catch (err) {
                            console.error("Insurance load failed:", err);
                          }
                        }}
                        styles={customStyles}
                        placeholder="Select Insurance Company"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuShouldBlockScroll={true}
                      />
                    </div>

                    {/* ===== MIDDLE : ADDONS ===== */}
                    <div className="insurance-middle">
                      <div className="insurance-section-title">
                        Insurance Add-ons
                      </div>

                      <div className="addons-grid-erp">
                        {[
                          ["Engine Protect", addEP, setAddEP],
                          ["Return To Invoice", addRTI, setAddRTI],
                          ["Consumables", addCM, setAddCM],
                          ["Personal Belongings", addPB, setAddPB],
                          ["Key Protect", addKP, setAddKP],
                          ["Zero Depreciation", addZD, setAddZD],
                          ["Nil Dep", addNilDep, setAddNilDep],
                          ["Road Side Assist", addRSA, setAddRSA],
                          ["EMI Cover", addEmiCover, setAddEmiCover],
                          ["Loss of Income", addLossIncome, setAddLossIncome],
                          ["Towing", addTowing, setAddTowing],
                          ["Emergency Hotel", addEmergency, setAddEmergency],
                          [
                            "Daily Allowance",
                            addDailyAllowance,
                            setAddDailyAllowance,
                          ],
                          ["Tyre Cover", addTyreCover, setAddTyreCover],
                          [
                            "Charger Protect",
                            addChargerProtection,
                            setAddChargerProtection,
                          ],
                          [
                            "Battery Cover",
                            addBatteryCover,
                            setAddBatteryCover,
                          ],
                        ].map(([label, value, setter]) => (
                          <label key={label} className="addon-tile">
                            <input
                              type="checkbox"
                              checked={value}
                              onChange={(e) => setter(e.target.checked)}
                            />
                            <span>{label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* ===== RIGHT : VALUES ===== */}
                    <div className="insurance-right">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div className="insurance-section-title">
                          Insurance Amount
                        </div>

                        <button
                          type="button"
                          className="insurance-plus-btn"
                          onClick={() => setShowInsurancePopup(true)}
                        >
                          +
                        </button>
                      </div>

                      <div className="insurance-values">
                        <div>
                          <label>Ex-Showroom (Auto)</label>
                          <input
                            className="input-imd"
                            value={exShowroom}
                            disabled
                          />
                        </div>

                        <div>
                          <label>Insurance Amount</label>
                          <input
                            className="input-imd"
                            value={insuranceAmount}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ================= RTO ================= */}
                <div
                  className="subheader-imd"
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>RTO</span>
                </div>
                <div className="rto-wrap">
                  {/* LEFT - TYPE */}
                  <div className="rto-left">
                    <div className="section-title">RTO Type</div>

                    <label>
                      <input
                        type="radio"
                        checked={rtoType === "InHouse"}
                        onChange={() => setRtoType("InHouse")}
                      />{" "}
                      In House
                    </label>

                    <label>
                      <input
                        type="radio"
                        checked={rtoType === "OutHouse"}
                        onChange={() => setRtoType("OutHouse")}
                      />{" "}
                      Out House
                    </label>

                    <label>
                      <input
                        type="radio"
                        checked={rtoType === "BH"}
                        onChange={() => setRtoType("BH")}
                      />{" "}
                      BH
                    </label>

                    {/* Vehicle Own Status */}
                    <div style={{ marginTop: "16px" }}>
                      <div className="section-title">Vehicle Own Status</div>

                      <label>
                        <input
                          type="radio"
                          value="one"
                          checked={vehicleOwnStatus === "one"}
                          onChange={(e) => setVehicleOwnStatus(e.target.value)}
                        />{" "}
                        1<sup>st</sup> Vehicle
                      </label>

                      <label>
                        <input
                          type="radio"
                          value="morethanone"
                          checked={vehicleOwnStatus === "morethanone"}
                          onChange={(e) => setVehicleOwnStatus(e.target.value)}
                        />{" "}
                        More Than One
                      </label>
                    </div>
                  </div>

                  {/* RIGHT - VALUES */}
                  <div className="rto-right">
                    <div>
                      <label>Ex Showroom</label>
                      <input
                        className="input-imd"
                        value={exShowroom}
                        disabled
                      />
                    </div>

                    <div>
                      <label>RTO Temporary</label>
                      <input
                        className="input-imd"
                        type="number"
                        value={rtoTemporary}
                        onChange={(e) => setRtoTemporary(e.target.value)}
                      />
                    </div>

                    <div className="municipal-row">
                      <label className="municipal-label">
                        <input
                          type="checkbox"
                          checked={municipalTax}
                          onChange={(e) => setMunicipalTax(e.target.checked)}
                        />
                        Municipal Tax
                      </label>

                      <input
                        className="input-imd municipal-input"
                        type="number"
                        value={municipalTax ? municipalAmount : 0}
                        onChange={(e) => setMunicipalAmount(e.target.value)}
                        disabled={!municipalTax}
                      />
                    </div>

                    <div>
                      <label>RTO Amount</label>

                      <div className="rto-amount-row">
                        <input
                          className="input-imd"
                          type="number"
                          value={rtoAmount}
                          onChange={(e) => setRtoAmount(e.target.value)}
                        />

                        <button
                          type="button"
                          className="rto-plus-btn"
                          onClick={() => setShowRtoPopup(true)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ================= TRC ================= */}
                <div
                  className="section-header-left"
                  style={{ marginTop: "20px" }}
                >
                  TRC
                </div>

                <div className="rto-wrap">
                  {/* LEFT */}
                  <div className="rto-left">
                    <div className="section-title">TRC Type</div>

                    <label>
                      <input
                        type="radio"
                        checked={trcType === "InHouse"}
                        onChange={() => setTrcType("InHouse")}
                      />{" "}
                      In House
                    </label>

                    <label>
                      <input
                        type="radio"
                        checked={trcType === "OutHouse"}
                        onChange={() => setTrcType("OutHouse")}
                      />{" "}
                      Out House
                    </label>
                  </div>

                  {/* RIGHT */}
                  <div className="rto-right">
                    <div>
                      <label>Specific Number</label>
                      <input
                        className="input-imd"
                        value={trcSpecificNo}
                        onChange={(e) => setTrcSpecificNo(e.target.value)}
                      />
                    </div>

                    <div>
                      <label>Amount (Specific No)</label>
                      <input
                        className="input-imd"
                        type="number"
                        value={trcSpecificAmount}
                        onChange={(e) => setTrcSpecificAmount(e.target.value)}
                      />
                    </div>
                    <div>
                      <label>Amount</label>
                      <input
                        className="input-imd"
                        type="number"
                        value={trcAmount}
                        onChange={(e) => setTrcAmount(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                {/* ================= PACKAGE PRICE (ALL STEPS) ================= */}
                <div className="package-price-row">
                  <label style={{ fontWeight: 600 }}>Package Price:</label>
                  <input
                    type="text"
                    value={packagePrice}
                    onChange={(e) => setPackagePrice(e.target.value)}
                    className="package-price-input"
                  />
                </div>

                <div className="footer-actions-imd">
                  <button className="exit-btn-imd" onClick={() => setStep(2)}>
                    Previous
                  </button>

                  <button
                    className="next-btn-imd"
                    onClick={async () => {
                      // ✅ VIEW MODE → skip API
                      if (mode === "VIEW") {
                        setStep(4);
                        return;
                      }

                      // ✅ ADD / EDIT → call API
                      const success = await handleFinalSave();
                      if (success) {
                        setStep(4);
                      }
                    }}
                  >
                    {mode === "VIEW"
                      ? "Next"
                      : mode === "ADD"
                        ? "Next"
                        : "Update & Next"}
                  </button>
                </div>
              </div>
            </>
          )}
          {step === 4 && (
            <>
              <div className="section-header-left">Accessories Details</div>
              <div className="inner-frame-imd">
                <div className="form-scroll-imd" style={{ padding: "0 10px" }}>
                  <div className="banner-imd">Package</div>
                  <div className="form-grid-imd" style={{ marginTop: "10px" }}>
                    <div className="form-item-imd">
                      <label>Package</label>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <div style={{ flex: 1 }}>
                          <Select
                            classNamePrefix="rs"
                            options={accPackageList}
                            value={
                              accPackageList.find(
                                (o) => o.value === accPackage,
                              ) || null
                            }
                            onChange={(s) => handlePackageChange(s)}
                            styles={customStyles}
                            placeholder="Select Package"
                          />
                        </div>
                        {false && (
                          <button
                            type="button"
                            className="rto-plus-btn"
                            onClick={() => {
                              if (!accPackage) {
                                alert("Please select package first");
                                return;
                              }
                              setShowAccPopup(true);
                            }}
                            style={{ minWidth: "40px" }}
                          >
                            +
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="form-item-imd">
                      <label>Amount</label>
                      <input
                        className="input-imd"
                        type="number"
                        value={accAmount}
                        onChange={(e) => setAccAmount(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Discount Amount</label>
                      <input
                        className="input-imd"
                        type="number"
                        value={accDiscount}
                        onChange={(e) => setAccDiscount(e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Total Amount</label>
                      <input
                        className="input-imd"
                        value={accTotalAmount}
                        readOnly
                        style={{ background: "#f2f2f2", fontWeight: 600 }}
                      />
                    </div>
                  </div>

                  <div className="banner-imd" style={{ marginTop: "25px" }}>
                    Other
                  </div>
                  <div className="form-grid-imd" style={{ marginTop: "10px" }}>
                    <div className="form-item-imd">
                      <label>Category</label>
                      <Select
                        options={accCategoryList}
                        value={
                          accCategoryList.find(
                            (o) => o.value === accCategory,
                          ) || null
                        }
                        onChange={(selected) => {
                          const cat = selected?.value || "";

                          setAccCategory(cat);

                          if (cat) {
                            loadPartNames(cat);
                          }
                        }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Part Name</label>
                      <Select
                        options={accPartNameList}
                        value={
                          accPartNameList.find(
                            (o) => o.value === accPartName,
                          ) || null
                        }
                        onChange={(selected) => {
                          const part = selected?.value || "";

                          setAccPartName(part);

                          if (part) {
                            loadPartDetail(part);
                          }
                        }}
                      />
                    </div>
                    <div className="form-item-imd">
                      <label>Part No</label>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <div style={{ flex: 1 }}>
                          <Select
                            classNamePrefix="rs"
                            options={accPartNoList}
                            value={
                              accPartNoList.find(
                                (o) => o.value === accPartNo,
                              ) || null
                            }
                            onChange={(selected) => {
                              const partNo = selected?.value || "";
                              setAccPartNo(partNo);

                              const row = accPartNoList.find(
                                (o) => o.value === partNo,
                              );

                              if (row) {
                                setAccMrp(Number(row.mrp || 0));
                              }
                            }}
                            styles={customStyles}
                            placeholder="Select Part No"
                          />
                        </div>
                        <button
                          className="next-btn-imd"
                          style={{
                            background: "#2fa84f",
                            padding: "0 15px",
                            height: "42px",
                            minWidth: "auto",
                          }}
                          onClick={handleAddAccessory}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="acc-grid-container"
                    style={{ marginTop: "20px" }}
                  >
                    <div
                      className="acc-grid-header"
                      style={{
                        gridTemplateColumns:
                          "40px 2fr 2fr 1.5fr 1fr 1fr 1fr 1fr",
                      }}
                    >
                      <div>#</div>
                      <div>Category</div>
                      <div>Part Name</div>
                      <div>Part No</div>
                      <div>MRP</div>
                      <div>QTY</div>
                      <div>Total</div>
                      <div>Action</div>
                    </div>
                    <div className="acc-grid-body">
                      {accOtherGrid.length > 0 ? (
                        accOtherGrid.map((row, index) => (
                          <div
                            key={row.id}
                            className="acc-grid-row"
                            style={{
                              gridTemplateColumns:
                                "40px 2fr 2fr 1.5fr 1fr 1fr 1fr 1fr",
                            }}
                          >
                            <div>{index + 1}</div>
                            <div>{row.category}</div>
                            <div>{row.partName}</div>
                            <div>{row.partNo}</div>
                            <div>{row.mrp.toFixed(2)}</div>
                            <div>{row.qty}</div>
                            <div style={{ fontWeight: "700" }}>
                              {row.total.toFixed(2)}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                className="delete-btn-imd"
                                onClick={() => handleDeleteAccessory(row.id)}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            padding: "30px",
                            textAlign: "center",
                            color: "#999",
                            fontSize: "14px",
                          }}
                        >
                          No accessories added
                        </div>
                      )}
                    </div>
                    {accOtherGrid.length > 0 && (
                      <div
                        className="acc-grid-footer"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          padding: "10px 20px",
                          background: "#f4f4f4",
                          borderTop: "1px solid #ddd",
                          fontSize: "13px",
                          fontWeight: "700",
                          gap: "20px",
                        }}
                      >
                        <div>
                          Total Qty ={" "}
                          {accOtherGrid.reduce((sum, r) => sum + r.qty, 0)}
                        </div>
                        <div>
                          Total Amount ={" "}
                          {accOtherGrid
                            .reduce((sum, r) => sum + r.total, 0)
                            .toFixed(2)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="package-price-row">
                  <label style={{ fontWeight: 600 }}>Package Price:</label>
                  <input
                    type="text"
                    value={packagePrice}
                    onChange={(e) => setPackagePrice(e.target.value)}
                    className="package-price-input"
                  />
                </div>

                <div className="footer-actions-imd">
                  <button className="exit-btn-imd" onClick={() => setStep(3)}>
                    Previous
                  </button>

                  <button
                    className="next-btn-imd"
                    onClick={async () => {
                      // ✅ VIEW MODE → skip API
                      if (mode === "VIEW") {
                        setStep(5);
                        return;
                      }

                      // ✅ ADD / EDIT → call API
                      const success = await handleFinalAceessSave();
                      if (success) {
                        setStep(5);
                      }
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
          {step === 5 && (
            <>
              <div className="subheader-imd">Other Details</div>

              <div className="inner-frame-imd">
                <div className="form-scroll-imd">
                  {/* ================= EXTENDED WARRANTY ================= */}

                  <div className="subheader-imd">Extended Warranty</div>

                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Warranty Type</label>
                      <Select
                        options={warrantyList}
                        value={
                          warrantyList.find((o) => o.value === warrantyType) ||
                          null
                        }
                        onChange={(selected) => {
                          const warranty = selected?.value || "";

                          setWarrantyType(warranty);

                          if (variant && warranty) {
                            loadWarrantyAmount(variant, warranty);
                          }
                        }}
                      />
                    </div>

                    <div className="form-item-imd">
                      <label>Amount</label>
                      <input
                        type="text"
                        className="input-imd"
                        value={warrantyAmount}
                        readOnly
                      />
                    </div>

                    <div className="form-item-imd">
                      <label>Shield Of Trust / AMC</label>
                      <Select
                        options={sotList}
                        value={sotList.find((o) => o.value === amcType) || null}
                        onChange={(selected) => {
                          const amc = selected?.value || "";
                          setAmcType(amc);

                          if (variant && amc) {
                            getAMCAmount(variant, amc);
                          }
                        }}
                      />
                    </div>

                    <div className="form-item-imd">
                      <label>Amount</label>
                      <input
                        className="input-imd"
                        value={amcAmount}
                        readOnly
                        style={{ background: "#f2f2f2", fontWeight: 600 }}
                      />
                    </div>

                    <div className="form-item-imd">
                      <label>Roadside Assistance</label>
                      <input
                        className="input-imd"
                        value={roadSide}
                        onChange={(e) => setRoadSide(e.target.value)}
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= LOGISTICS ================= */}

                  <div className="subheader-imd">Logistics</div>

                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Logistics</label>

                      <div style={{ display: "flex", gap: "15px" }}>
                        <label>
                          <input
                            type="radio"
                            checked={logistics === true}
                            onChange={() => setLogistics(true)}
                          />{" "}
                          Yes
                        </label>

                        <label>
                          <input
                            type="radio"
                            checked={logistics === false}
                            onChange={() => setLogistics(false)}
                          />{" "}
                          No
                        </label>
                      </div>
                    </div>

                    <div className="form-item-imd">
                      <label>Logistics Amount</label>

                      <input
                        className="input-imd"
                        value={logisticsAmount}
                        onChange={(e) => setLogisticsAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= FAST TAG ================= */}

                  <div className="subheader-imd">Fast Tag</div>

                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Fast Tag</label>

                      <div style={{ display: "flex", gap: "15px" }}>
                        <label>
                          <input
                            type="radio"
                            checked={fastTag === true}
                            onChange={() => setFastTag(true)}
                          />{" "}
                          Yes
                        </label>

                        <label>
                          <input
                            type="radio"
                            checked={fastTag === false}
                            onChange={() => setFastTag(false)}
                          />{" "}
                          No
                        </label>
                      </div>
                    </div>

                    <div className="form-item-imd">
                      <label>Fast Tag Amount</label>

                      <input
                        className="input-imd"
                        value={fastTagAmount}
                        onChange={(e) => setFastTagAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= NITROGEN ================= */}

                  <div className="subheader-imd">Nitrogen Gas</div>

                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Nitrogen Gas</label>

                      <div style={{ display: "flex", gap: "15px" }}>
                        <label>
                          <input
                            type="radio"
                            checked={nitrogen === true}
                            onChange={() => setNitrogen(true)}
                          />{" "}
                          Yes
                        </label>

                        <label>
                          <input
                            type="radio"
                            checked={nitrogen === false}
                            onChange={() => setNitrogen(false)}
                          />{" "}
                          No
                        </label>
                      </div>
                    </div>

                    <div className="form-item-imd">
                      <label>Amount</label>

                      <input
                        className="input-imd"
                        value={nitrogenAmount}
                        onChange={(e) => setNitrogenAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= EXCHANGE ================= */}

                  <div className="subheader-imd">Exchange Value</div>

                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Amount</label>

                      <input
                        className="input-imd"
                        value={exchangeAmount}
                        onChange={(e) => setExchangeAmount(e.target.value)}
                      />
                    </div>
                  </div>
                  <br></br>
                  {/* ================= OTHER ================= */}

                  <div className="subheader-imd">Other Details</div>

                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Other</label>

                      <Select
                        options={otherList}
                        value={
                          otherList.find((o) => o.value === step5OtherType) ||
                          null
                        }
                        onChange={(selected) =>
                          setStep5OtherType(selected?.value || "")
                        }
                      />
                    </div>

                    <div className="form-item-imd">
                      <label>Other Amount</label>

                      <input
                        className="input-imd"
                        value={step5OtherAmount}
                        onChange={(e) => setStep5OtherAmount(e.target.value)}
                      />
                    </div>

                    <div
                      className="form-item-imd"
                      style={{ display: "flex", alignItems: "flex-end" }}
                    >
                      <button
                        className="next-btn-imd"
                        style={{ background: "#2fa84f" }}
                        onClick={handleAddOtherStep5}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
                {step5OtherGrid.length > 0 && (
                  <div
                    style={{ marginTop: "15px", border: "1px solid #8B1E3F" }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "4fr 2fr 1fr",
                        background: "#8B1E3F",
                        color: "#fff",
                        padding: "8px",
                        fontWeight: 600,
                      }}
                    >
                      <div>Type</div>
                      <div>Amount</div>
                      <div>Action</div>
                    </div>

                    {step5OtherGrid.map((row) => (
                      <div
                        key={row.id}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "4fr 2fr 1fr",
                          padding: "8px",
                          borderTop: "1px solid #ddd",
                          alignItems: "center",
                        }}
                      >
                        <div>{row.type}</div>
                        <div>{row.amount}</div>

                        <div>
                          <button
                            style={{
                              background: "#d9534f",
                              color: "#fff",
                              border: "none",
                              padding: "4px 10px",
                              borderRadius: "4px",
                            }}
                            onClick={() =>
                              setStep5OtherGrid(
                                step5OtherGrid.filter((r) => r.id !== row.id),
                              )
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <br></br>
                {/* ================= FOOTER BUTTONS ================= */}

                <div className="footer-actions-imd">
                  <button className="exit-btn-imd" onClick={() => setStep(4)}>
                    Previous
                  </button>
                  {/* CENTER */}
                  <div className="footer-center">
                    <button className="next-btn-imd" onClick={() => setStep(6)}>
                      Next
                    </button>
                  </div>

                  <button
                    className="next-btn-imd"
                    style={{ background: "#2fa84f" }}
                    onClick={async () => {
                      // ✅ VIEW MODE → skip API
                      if (mode === "VIEW") {
                        navigate("/BookingDocketGrid"); // or wherever you want to redirect
                        return;
                      }

                      // ✅ ADD / EDIT → call API
                      await handleSaveStep5();
                    }}
                  >
                    Next & Finish
                  </button>
                </div>
              </div>
            </>
          )}
          {step === 6 && (
            <>
              <div className="subheader-imd">Remarks</div>

              <div className="inner-frame-imd">
                <div className="form-scroll-imd">
                  <div className="form-grid-imd">
                    <div className="form-item-imd">
                      <label>Customer Remark</label>
                      <textarea
                        className="input-imd"
                        rows={3}
                        value={custRemark1}
                        onChange={(e) => setCustRemark1(e.target.value)}
                      ></textarea>
                    </div>

                    <div className="form-item-imd">
                      <label>Remark</label>
                      <textarea
                        className="input-imd"
                        rows={3}
                        value={custRemark2}
                        onChange={(e) => setCustRemark2(e.target.value)}
                      ></textarea>
                    </div>

                    <div className="form-item-imd">
                      <label>Remark</label>
                      <textarea
                        className="input-imd"
                        rows={3}
                        value={custRemark3}
                        onChange={(e) => setCustRemark3(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>

                {/* FOOTER */}
                <div className="footer-actions-imd">
                  <button className="exit-btn-imd" onClick={() => setStep(5)}>
                    Previous
                  </button>

                  <button onClick={handleSubmitStep6}>Submit</button>
                </div>
              </div>
            </>
          )}
          <div className="global-footer-actions-imd">
            {mode !== "ADD" &&
              mode !== "VIEW" &&
              status !== "Approve" &&
              status !== "OnHold" && (
                <button className="approve-btn-imd" onClick={handleApprove}>
                  Approve
                </button>
              )}
            <button className="exit-btn-imd" onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>
      {showCityModal && (
        <div className="modal-overlay">
          <div className="city-modal">
            <div className="modal-header">
              <span>Add City</span>
              <span
                className="close-btn"
                onClick={() => setShowCityModal(false)}
              >
                ✖
              </span>
            </div>
            <div className="modal-body">
              <div className="city-grid">
                <div>
                  <label>State *</label>
                  <input
                    type="text"
                    value={newCityStateName}
                    readOnly
                    style={{ background: "#eee", fontWeight: "bold" }}
                  />
                </div>
                <div>
                  <label>City *</label>
                  <input
                    type="text"
                    value={newCityName}
                    onChange={(e) =>
                      setNewCityName(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-save" onClick={handleCitySave}>
                Save
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowCityModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showAreaModal && (
        <div className="modal-overlay">
          <div className="city-modal">
            <div className="modal-header">
              <span>Add Area</span>
              <span
                className="close-btn"
                onClick={() => setShowAreaModal(false)}
              >
                ✖
              </span>
            </div>
            <div className="modal-body">
              <div className="modal-body">
                <div className="area-grid">
                  <div>
                    <label>City *</label>
                    <input
                      type="text"
                      value={newAreaCityName}
                      readOnly
                      className="modal-input"
                    />
                  </div>
                  <div>
                    <label>Area *</label>
                    <input
                      type="text"
                      value={newAreaName}
                      onChange={(e) =>
                        setNewAreaName(
                          e.target.value.replace(/[^a-zA-Z ]/g, ""),
                        )
                      }
                      className="modal-input"
                    />
                  </div>
                  <div className="zip-full">
                    <label>Zip Code *</label>
                    <input
                      type="text"
                      value={newZipCode}
                      maxLength="6"
                      onChange={(e) =>
                        setNewZipCode(e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="modal-input"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-save" onClick={handleAreaSave}>
                Save
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowAreaModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showInsurancePopup && (
        <div className="modal-overlay">
          <div className="erp-insurance-popup">
            {/* HEADER */}
            <div className="erp-popup-header">
              <span>Insurance</span>
              <span
                className="close-btn"
                onClick={() => setShowInsurancePopup(false)}
              >
                ✖
              </span>
            </div>

            {/* BODY */}
            <div className="erp-popup-body">
              <div className="erp-grid-6">
                {/* ROW 1 */}
                <div className="erp-field">
                  <label>CESS</label>
                  <input readOnly value={insuranceMaster.cess || 0} />
                </div>

                <div className="erp-field">
                  <label>CESS Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.cessAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>IDV %</label>
                  <input readOnly value={insuranceMaster.idv || 0} />
                </div>

                <div className="erp-field">
                  <label>IDV Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.idvAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>After IDV</label>
                  <input
                    readOnly
                    value={insuranceCalc.idvAmount?.toFixed(2) || 0}
                  />
                </div>

                <div className="erp-field">
                  <label>Insurance %</label>
                  <input readOnly value={insuranceMaster.insurance_per || 0} />
                </div>

                <div className="erp-field">
                  <label>Insurance Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.odPremium?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>Discount %</label>
                  <input readOnly value={insuranceMaster.discount_per || 0} />
                </div>
                <div className="erp-field">
                  <label>Discount Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.discountAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>After Discount</label>
                  <input
                    readOnly
                    value={insuranceCalc.afterDiscount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>CNG %</label>
                  <input readOnly value={insuranceMaster.cng_per || 0} />
                </div>

                <div className="erp-field">
                  <label>CNG Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.cngAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>PA Cover</label>
                  <input readOnly value={insuranceMaster.pa_cover || 0} />
                </div>
                {/* ROW 2 */}
                <div className="erp-field">
                  <label>ZD %</label>
                  <input readOnly value={insuranceMaster.zd_per || 0} />
                </div>

                <div className="erp-field">
                  <label>ZD Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.zdAmount?.toFixed(2) || 0}
                  />
                </div>

                <div className="erp-field">
                  <label>EP %</label>
                  <input readOnly value={insuranceMaster.ep_per || 0} />
                </div>

                <div className="erp-field">
                  <label>EP Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.epAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>PB</label>
                  <input readOnly value={insuranceMaster.pb_per || 0} />
                </div>
                <div className="erp-field">
                  <label>Third Party</label>
                  <input readOnly value={insuranceMaster.third_party || 0} />
                </div>
                <div className="erp-field">
                  <label>KP %</label>
                  <input readOnly value={insuranceMaster.kp_per || 0} />
                </div>

                <div className="erp-field">
                  <label>KP Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.kpAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>Paid Driver</label>
                  <input readOnly value={insuranceMaster.paid_driver || 0} />
                </div>
                <div className="erp-field">
                  <label>After PD</label>
                  <input
                    readOnly
                    value={insuranceCalc.afterDiscount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>RTI %</label>
                  <input readOnly value={insuranceMaster.rti_per || 0} />
                </div>

                <div className="erp-field">
                  <label>RTI Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.rtiAmount?.toFixed(2) || 0}
                  />
                </div>

                {/* ROW 3 */}
                <div className="erp-field">
                  <label>CM %</label>
                  <input readOnly value={insuranceMaster.cm_per || 0} />
                </div>
                <div className="erp-field">
                  <label>CM Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.cmAmount?.toFixed(2) || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>GST %</label>
                  <input readOnly value={insuranceMaster.gst || 0} />
                </div>

                <div className="erp-field">
                  <label>CGST</label>
                  <input readOnly value={(insuranceMaster.gst || 0) / 2} />
                </div>

                <div className="erp-field">
                  <label>SGST</label>
                  <input readOnly value={(insuranceMaster.gst || 0) / 2} />
                </div>
                <div className="erp-field">
                  <label>GST Amount</label>
                  <input
                    readOnly
                    value={insuranceCalc.gstAmount?.toFixed(2) || 0}
                  />
                </div>

                {/* ROW 4 */}

                <div className="erp-field">
                  <label>NCB</label>
                  <input readOnly value={insuranceMaster.ncb || 0} />
                </div>

                <div className="erp-field">
                  <label>NIL Depreciation</label>
                  <input readOnly value={insuranceMaster.nil_dep || 0} />
                </div>

                <div className="erp-field">
                  <label>RSA</label>
                  <input readOnly value={insuranceMaster.rsa || 0} />
                </div>

                {/* ROW 5 */}
                <div className="erp-field">
                  <label>EMI Cover</label>
                  <input readOnly value={insuranceMaster.emi_cover || 0} />
                </div>

                <div className="erp-field">
                  <label>Loss Of Income</label>
                  <input readOnly value={insuranceMaster.loss_income || 0} />
                </div>
                <div className="erp-field">
                  <label>Consumables</label>
                  <input readOnly value={insuranceMaster.consumables || 0} />
                </div>
                <div className="erp-field">
                  <label>Towing</label>
                  <input readOnly value={insuranceMaster.towing || 0} />
                </div>
                <div className="erp-field">
                  <label>Daily Allowance</label>
                  <input readOnly value={insuranceMaster.daily_allow || 0} />
                </div>
                <div className="erp-field">
                  <label>Tyre & Allow Cover</label>
                  <input readOnly value={insuranceMaster.tyre_cover || 0} />
                </div>
                <div className="erp-field">
                  <label>Emergency Exp.</label>
                  <input readOnly value={insuranceMaster.emergency_exp || 0} />
                </div>
                <div className="erp-field">
                  <label>Charger Protection</label>
                  <input
                    readOnly
                    value={insuranceMaster.charger_protection || 0}
                  />
                </div>
                <div className="erp-field">
                  <label>Battery Cover</label>
                  <input readOnly value={insuranceMaster.battery_cover || 0} />
                </div>

                {/* ROW 6 */}
              </div>

              {/* FINAL TOTAL */}
              <div className="insurance-total-row">
                <label>Insurance Amount :</label>
                <input
                  readOnly
                  value={insuranceCalc.finalInsurance?.toFixed(2) || 0}
                />
              </div>

              {/* FOOTER */}
              <div className="erp-footer">
                <button
                  className="next-btn-imd"
                  onClick={() => setShowInsurancePopup(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showRtoPopup && (
        <div className="modal-overlay">
          <div className="erp-rto-popup">
            <div className="erp-popup-header">
              <span>RTO</span>
              <span
                className="close-btn"
                onClick={() => setShowRtoPopup(false)}
              >
                ✖
              </span>
            </div>

            <div className="erp-popup-body">
              <div className="erp-grid">
                {/* Column 1 */}
                <div className="erp-field">
                  <label>Amount</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.amount || rtoAmount}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        amount: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Add Less</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.addLess}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, addLess: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>RTO Rate</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.rtoRate}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, rtoRate: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>RTO Tax Surcharge</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.rtoTaxSurcharge}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        rtoTaxSurcharge: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Green Tax</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.greenTax}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, greenTax: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Reg Fee</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.regFee}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, regFee: e.target.value })
                    }
                  />
                </div>

                {/* Second Row */}

                <div className="erp-field">
                  <label>HPN</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.hpn}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, hpn: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Duplicate</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.duplicate}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, duplicate: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Smart Card</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.smartCard}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, smartCard: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Other</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.other}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, other: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>BH Year</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.bhYear}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, bhYear: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Local Tax</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.localTax}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, localTax: e.target.value })
                    }
                  />
                </div>

                {/* Third Row */}

                <div className="erp-field">
                  <label>Road Safety Tax</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.roadSafetyTax}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        roadSafetyTax: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>MCD Charge</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.mcdCharge}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, mcdCharge: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Other Charges</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.otherCharges}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        otherCharges: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>CNG Kit</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.cngKit}
                    onChange={(e) =>
                      setRtoFields({ ...rtoFields, cngKit: e.target.value })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Number Plate</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.numberPlate}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        numberPlate: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="erp-field">
                  <label>Excluding Tax</label>
                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.excludingTax}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        excludingTax: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Scrapage Section */}
                <div className="erp-field scrapage-box">
                  <label>
                    <input
                      type="checkbox"
                      checked={rtoFields.scrapage}
                      onChange={(e) =>
                        setRtoFields({
                          ...rtoFields,
                          scrapage: e.target.checked,
                        })
                      }
                    />
                    Scrapage
                  </label>

                  <input
                    type="number"
                    className="input-imd"
                    value={rtoFields.scrapage ? rtoFields.scrapageAmount : ""}
                    disabled={!rtoFields.scrapage}
                    onChange={(e) =>
                      setRtoFields({
                        ...rtoFields,
                        scrapageAmount: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="erp-footer">
                <button
                  className="next-btn-imd"
                  onClick={() => setShowRtoPopup(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAccPopup && (
        <div className="modal-overlay">
          <div className="erp-package-popup">
            {/* HEADER */}
            <div className="erp-popup-header">
              <span>Package Details</span>
              <span
                className="close-btn"
                onClick={() => setShowAccPopup(false)}
              >
                ✖
              </span>
            </div>

            {/* BODY */}
            <div className="package-popup-body">
              <div className="package-table">
                <div className="package-table-header">
                  <div></div>
                  <div>Category</div>
                  <div>MRP</div>
                  <div>Qty</div>
                  <div>Compulsory</div>
                </div>

                {accPackageDetails.map((row, index) => (
                  <div key={index} className="package-table-row">
                    <div>
                      <input type="checkbox" defaultChecked />
                    </div>

                    <div>
                      <input
                        className="pkg-input"
                        value={row.category}
                        readOnly
                      />
                    </div>

                    <div>
                      <input
                        type="number"
                        className="pkg-input"
                        value={row.mrp}
                        readOnly
                      />
                    </div>

                    <div>
                      <input
                        type="number"
                        className="pkg-input"
                        value={row.qty}
                        readOnly
                      />
                    </div>

                    <div>
                      <input className="pkg-input" value="True" readOnly />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            <div className="erp-footer">
              <button className="next-btn-imd">SAVE</button>
            </div>
            <br></br>
          </div>
        </div>
      )}

      {/* STYLES */}
      <style>{`
/* ================= GLOBAL RESET ================= */
html, body {
  width: 100%;
  overflow-x: hidden;
}
* {
  box-sizing: border-box;
  max-width: 100vw;
  font-family: "Segoe UI", Arial, sans-serif;
}
/* ================= REACT SELECT PREMIUM FIX ================= */
.rs__menu-portal {
  z-index: 999999 !important;
}
.rs__menu {
  max-width: 95vw !important;
  border-radius: 8px !important;
  overflow: hidden;
}
.rs__control {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  background: #fcfcfc !important;
  border: 1px solid #d8d8d8 !important;
  border-radius: 8px !important;
  min-height: 42px !important;
  transition: all .2s ease;
}
.rs__control:hover {
  border-color: #8B1E3F !important;
}
.rs__control--is-focused {
  border-color: #8B1E3F !important;
  box-shadow: 0 0 0 2px rgba(139,30,63,.15) !important;
}
.rs__value-container {
  padding: 0 14px !important;
}
.rs__placeholder {
  color: #8f8f8f !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
}
.rs__single-value {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: 500;
}
.rs__indicator-separator {
  display: none !important; /* remove ugly divider */
}
.rs__dropdown-indicator {
  color: #666 !important;
}
/* ================= PAGE ================= */
.page-container-imd {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
}
.container-imd {
  width: 100%;
  max-width: 1600px;
  background: #ffffff;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 6px 18px rgba(0,0,0,.08);
}
/* ================= HEADERS ================= */
.header-imd {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  padding: 14px;
  color: #fff;
  border-radius: 8px;
  margin-bottom: 14px;
  background: #8B1E3F;
}
.subheader-imd {
  font-size: 14px;
  font-weight: 700;
  color: #8B1E3F;
  padding: 8px 12px;
  background: #f9e6ec;
  border-left: 4px solid #8B1E3F;
  border-radius: 6px;
  margin-bottom: 14px;
}
/* ================= INNER FRAME ================= */
.inner-frame-imd {
  border: 2px solid #8B1E3F;
  border-radius: 8px;
  padding: 14px;
  height: 78vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}
/* ================= SCROLL ================= */
.form-scroll-imd {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 6px;
}
/* ================= GRID ================= */
.form-grid-imd {
  display: grid;
  gap: 16px;
  width: 100%;
}
.form-item-imd {
  display: flex;
  flex-direction: column;
}
/* XL */
/* XXL */
@media (min-width: 1400px) {
  .form-grid-imd { grid-template-columns: repeat(4, 1fr); }
}
/* XL */
@media (min-width: 1200px) and (max-width: 1399px) {
  .form-grid-imd { grid-template-columns: repeat(3, 1fr); }
}
/* LG */
@media (min-width: 992px) and (max-width: 1199px) {
  .form-grid-imd { grid-template-columns: repeat(3, 1fr); }
}
/* MD */
@media (min-width: 768px) and (max-width: 991px) {
  .form-grid-imd { grid-template-columns: repeat(2, 1fr); }
}
/* SM */
@media (min-width: 576px) and (max-width: 767px) {
  .form-grid-imd { grid-template-columns: 1fr; }
}
/* XS */
@media (max-width: 575px) {
  .form-grid-imd { grid-template-columns: 1fr; }
  .header-imd { font-size: 1.2rem; padding: 10px; }
  .subheader-imd { font-size: 13px; }
}

/* ================= LABEL ================= */
.form-item-imd label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #444;
}
/* ================= INPUTS ================= */
.input-imd {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #d8d8d8;
  background: #fcfcfc;
  transition: all .2s ease;
}
.input-imd::placeholder {
  color: #8f8f8f;
  font-size: 13.5px;
  font-weight: 500;
}
.input-imd:hover {
  border-color: #8B1E3F;
}
.input-imd:focus {
  border-color: #8B1E3F;
  box-shadow: 0 0 0 2px rgba(139,30,63,.15);
  outline: none;
}
/* ================= CITY + AREA ================= */
.city-wrapper {
  display: flex;
  gap: 8px;
}
.city-select { flex: 1; }
.city-add-btn {
  min-width: 42px;
  height: 42px;
  border-radius: 8px;
  border: none;
  background: #8B1E3F;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: .2s;
}
.city-add-btn:hover {
  background: #6e1630;
}
/* ================= FILE PREVIEW ================= */
.aadhaar-preview {
  margin-top: 8px;
  width: 100%;
  max-width: 260px;
  height: 160px;
  border-radius: 10px;
  border: 1px solid #ddd;
  background: #f8f8f8;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.aadhaar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* ================= UPLOAD BUTTON ================= */
.btn-upload {
  margin-top: 8px;
  padding: 8px 16px;
  background: #8B1E3F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: .2s;
}
.btn-upload:hover {
  background: #6e1630;
}
/* ================ FOOTER ================= */
.footer-actions-imd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 14px;
  margin-top: 12px;
  border-top: 1px solid #eee;
}
/* Global Exit button row (shown on all steps) */
.global-footer-actions-imd {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 0 6px 0;
  margin-top: 10px;
  border-top: 2px solid #eee;
}
.next-btn-imd {
  background: #8B1E3F;
  color: #fff;
  border: none;
  padding: 9px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: .2s;
  white-space: nowrap;
}
.next-btn-imd:hover {
  background: #6e1630;
}
.exit-btn-imd {
  background: #ab2025;
  color: #fff;
  border: none;
  padding: 9px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: .2s;
  min-height: 44px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
.exit-btn-imd:hover {
  background: #b02a37;
}
.approve-btn-imd {
  background: #28a745;
  color: #fff;
  border: none;
  padding: 9px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: .2s;
}
.approve-btn-imd:hover {
  background: #1e7e34;
}
/* ================= MODALS ================= */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}
.city-modal {
  width: 520px;
  max-width: 95vw;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(0,0,0,.25);
}
.modal-header {
  background: #8B1E3F;
  color: #fff;
  padding: 14px 18px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
}
.modal-body {
  padding: 18px;
}
.modal-footer {
  display: flex;
  justify-content: center;
  gap: 14px;
  padding: 16px;
}
/* ================= MODAL GRID ================= */
.city-grid,
.area-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}
.area-grid .zip-full { grid-column: span 2; }
@media (max-width: 768px) {
  .city-grid,
  .area-grid { grid-template-columns: 1fr; }
  .area-grid .zip-full { grid-column: span 1; }
}
.modal-input {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 100%;
}

/* ===== INSURANCE ERP LAYOUT ===== */

/* ===== STEP 3 PREMIUM INSURANCE ===== */

.step-insurance {
  height: auto !important;
  min-height: 420px;
}

.insurance-wrap {
  display: grid;
  grid-template-columns: 1.6fr 3fr 1.4fr;
  gap: 22px;
  background: #fafafa;
  padding: 18px;
  border-radius: 14px;
  border: 1px solid #eee;
}
.insurance-left {
  order: 1;   /* Insurance Type stays LEFT */
}

.insurance-middle {
  order: 2;   /* Add-ons middle */
}

.insurance-right {
    order: 3;   /* Values move RIGHT */
  background: #ffffff;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #eee;
  box-shadow: 0 2px 6px rgba(0,0,0,.04);
}


.insurance-section-title {
  font-weight: 700;
  color: #8B1E3F;
  margin-bottom: 12px;
  font-size: 14px;
}


.insurance-type-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.insurance-values {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.insurance-values input {
  font-weight: 700;
  background: #f6f7ff;
  border: 1px solid #cfd4ff;
}

.addons-grid-erp {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  font-size: 13px;
}

.addon-tile {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f6f8;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all .2s ease;
  border: 1px solid transparent;
}

.addon-tile:hover {
  background: #f0e4ea;
  border-color: #8B1E3F;
}

.addon-tile input {
  accent-color: #8B1E3F;
}

.addon-tile input:checked + span {
  font-weight: 700;
}

@media (max-width: 1100px) {
  .insurance-wrap {
    grid-template-columns: 1fr;
  }

  .addons-grid-erp {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .addons-grid-erp {
    grid-template-columns: repeat(2, 1fr);
  }
}

  /* ================= MOBILE PERFECT INSURANCE ================= */

/* Tablets */
@media (max-width: 1100px) {
  .insurance-wrap {
    grid-template-columns: 1fr;
  }

  .addons-grid-erp {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Small phones */
@media (max-width: 600px) {
  .container-imd {
    padding: 10px;
  }

  .inner-frame-imd {
    padding: 10px;
  }

  .insurance-wrap {
    padding: 12px;
    gap: 14px;
  }

  .insurance-left,
  .insurance-middle,
  .insurance-right {
    padding: 12px;
  }

  .insurance-values input {
    font-size: 13px;
  }

  .addons-grid-erp {
    grid-template-columns: 1fr;
  }

  .addon-tile {
    font-size: 12.5px;
    padding: 10px;
  }

  .insurance-section-title {
    font-size: 13px;
  }
}

/* Extra small devices */
@media (max-width: 420px) {
  .header-imd {
    font-size: 1.1rem;
    padding: 8px;
  }

  .subheader-imd {
    font-size: 12px;
  }

  .addon-tile {
    flex-direction: row;
    gap: 8px;
  }

  .input-imd {
    padding: 9px 12px;
    font-size: 13px;
  }
  
  .next-btn-imd, .exit-btn-imd {
    padding: 8px 16px;
    font-size: 13px;
  }
}

  /* ===== INSURANCE PLUS BUTTON ===== */
.insurance-plus-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #8B1E3F;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: .2s;
}

.insurance-plus-btn:hover {
  background: #6e1630;
}

/* ===== INSURANCE POPUP ===== */

/* ===== FULL ERP INSURANCE POPUP ===== */

/* ===== INSURANCE ERP POPUP ===== */

.erp-insurance-popup {
  width: 1200px;
  max-width: 95vw;
  max-height: 90vh;            /* Important */
  background: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 25px 50px rgba(0,0,0,.4);
  display: flex;
  flex-direction: column;
}
.erp-popup-header {
  background: #8B1E3F;
  color: #fff;
  padding: 14px 22px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-btn {
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all .2s;
}
.close-btn:hover {
  background: rgba(255,255,255,0.1);
  transform: scale(1.1);
}

.erp-popup-body {
  padding: 25px 30px;
  overflow-y: auto;             /* 🔥 makes popup scrollable */
  overflow-x: hidden;
  flex: 1;
}

.erp-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 18px;
}

.erp-field {
  display: flex;
  flex-direction: column;
}

.erp-field label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #444;
}

.erp-field input {
  height: 32px;
  width: 100%;
  background: #e6e3dc;
  border: 1px solid #cfcac2;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 6px;
}

.insurance-total-box {
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 14px;
  font-weight: 700;
}

.total-input {
  width: 220px;
  font-weight: bold;
  background: #ffffff;
}

.erp-footer {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* Responsive */
@media (max-width: 1200px) {
  .erp-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 800px) {
  .erp-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 500px) {
  .erp-grid {
    grid-template-columns: 1fr;
  }
}
  /* ================= RTO + TRC ================= */

.rto-wrap {
  display: grid;
  grid-template-columns: 1.2fr 3fr;
  gap: 24px;
  background: #fafafa;
  padding: 18px;
  border-radius: 12px;
  border: 1px solid #eee;
}

.rto-left {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rto-right {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.section-title {
  font-weight: 700;
  color: #8B1E3F;
  margin-bottom: 10px;
}

.municipal-check {
  display: flex;
  align-items: center;
  margin-top: 24px;
}

@media (max-width: 900px) {
  .rto-wrap {
    grid-template-columns: 1fr;
  }

  .rto-right {
    grid-template-columns: 1fr;
  }
}
  /* Municipal Inline Layout */
.municipal-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 26px;
}

.municipal-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  white-space: nowrap;
}

.municipal-input {
  width: 120px;
  font-weight: 600;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .municipal-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .municipal-input {
    width: 100%;
  }
}
  /* ===== RTO ERP POPUP ===== */

.erp-rto-popup {
  width: 1100px;
  max-width: 96vw;
  max-height: 90vh;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0,0,0,.35);
  display: flex;
  flex-direction: column;
}

/* Grid layout same as insurance */
.erp-rto-popup .erp-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
}

/* Responsive */
@media (max-width: 1200px) {
  .erp-rto-popup .erp-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 800px) {
  .erp-rto-popup .erp-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 500px) {
  .erp-rto-popup .erp-grid {
    grid-template-columns: 1fr;
  }
}
  .scrapage-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
  /* RTO Amount + Button Layout */
.rto-amount-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rto-amount-row input {
  flex: 1;
}

.rto-plus-btn {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  border: none;
  background: #8B1E3F;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: .2s;
}

.rto-plus-btn:hover {
  background: #6e1630;
}
  /* ERP Left Style Section Header */
.section-header-left {
  font-size: 14px;
  font-weight: 700;
  color: #8B1E3F;
  padding: 8px 14px;
  background: #f9e6ec;
  border-left: 6px solid #8B1E3F;
  border-radius: 6px;
  margin-bottom: 14px;
  text-align: left;
}
  .rs__menu-portal {
  z-index: 999999 !important;
}

.rs__menu {
  position: absolute !important;
  z-index: 999999 !important;
}
  /* ===== FULL ERP INSURANCE POPUP ===== */

.erp-insurance-popup-large {
  width: 1200px;
  max-width: 96vw;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0,0,0,.35);
}

.erp-grid-6 {
  display: grid;
  gap: 18px 22px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

/* Responsive */
@media (max-width: 1200px) {
  .erp-grid-6 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 800px) {
  .erp-grid-6 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 500px) {
  .erp-grid-6 {
    grid-template-columns: 1fr;
  }
}
  /* ===== OVERLAY ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* ===== POPUP ===== */
.erp-insurance-popup {
  width: 1150px;
  max-width: 96vw;
  background: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 20px 40px rgba(0,0,0,.4);
  overflow: hidden;
}

/* ===== HEADER ===== */
.erp-popup-header {
  background: #8B1E3F;
  color: #fff;
  padding: 14px 22px;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
}

/* ===== BODY ===== */


/* ===== GRID ===== */
.erp-grid-6 {
  display: grid;
  gap: 18px 22px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

/* ===== FIELD ===== */
.erp-field {
  display: flex;
  flex-direction: column;
}

.erp-field label {
  font-size: 12px;
  margin-bottom: 5px;
  font-weight: 600;
  color: #333;
}

.erp-field input {
  height: 32px;
  width: 100%;
  background: #e6e3dc;
  border: 1px solid #cfcac2;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 6px;
}

/* ===== TOTAL ===== */
.insurance-total-row {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
}

.insurance-total-row input {
  width: 180px;
  height: 28px;
}
/* ===== FOOTER ===== */
.erp-footer {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.next-btn-imd {
  background: #8B1E3F;
  color: #fff;
  border: none;
  padding: 8px 26px;
  border-radius: 6px;
  cursor: pointer;
}
  @media (max-width: 768px) {

  .erp-insurance-popup,
  .erp-rto-popup {
    width: 98vw;
    max-height: 95vh;
    border-radius: 6px;
  }

  .erp-popup-body {
    padding: 18px;
  }

  .insurance-total-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

}
/* ================= ACCESSORIES DESIGN ================= */
.banner-imd {
  background: #8B1E3F;
  color: #fff;
  padding: 10px;
  text-align: center;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}

.acc-grid-container {
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
}

.acc-grid-header {
  display: grid;
  grid-template-columns: 40px 1.5fr 3fr 2fr 1.5fr 1fr 1.5fr 1fr;
  background: #8B1E3F;
  color: #fff;
  padding: 12px;
  font-weight: 600;
  font-size: 13px;
}

.acc-grid-body {
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
}

.acc-grid-row {
  display: grid;
  grid-template-columns: 40px 1.5fr 3fr 2fr 1.5fr 1fr 1.5fr 1fr;
  padding: 12px;
  border-bottom: 1px solid #eee;
  align-items: center;
  font-size: 13px;
  transition: background 0.2s;
}

.acc-grid-row:hover {
  background: #f9f9f9;
}

.acc-grid-row:last-child {
  border-bottom: none;
}

.delete-btn-imd {
  background: #dc3545;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.delete-btn-imd:hover {
  background: #bd2130;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .acc-grid-header {
    display: none;
  }
  .acc-grid-row {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 15px;
  }
}

/* ================= PACKAGE PRICE RESPONSIVE ================= */
.package-price-row {
  margin-top: 20px;
  padding: 15px;
  border-top: 2px solid #8B1E3F;
  display: flex;
  align-items: center;
  gap: 20px;
}
.package-price-input {
  width: 260px;
  max-width: 100%;
  padding: 8px 12px;
  border: 1px solid #000;
  border-radius: 6px;
  font-weight: bold;
}
@media (max-width: 600px) {
  .package-price-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .package-price-input {
    width: 100%;
  }
}
@media (max-width: 600px) {
  .footer-actions-imd {
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  .global-footer-actions-imd {
    justify-content: center;
    gap: 10px;
  }
  .next-btn-imd,
  .exit-btn-imd,
  .approve-btn-imd {
    width: 100%;
    text-align: center;
    min-height: 44px;
    font-size: 14px;
    padding: 10px 16px;
    box-sizing: border-box;
  }
}
@media (max-width: 400px) {
  .next-btn-imd,
  .exit-btn-imd,
  .approve-btn-imd {
    font-size: 13px;
    padding: 8px 16px;
  }
}
 /* ===== PACKAGE POPUP ===== */
.erp-package-popup{
  width:700px;
  max-width:95vw;
  background:#fff;
  border-radius:8px;
  box-shadow:0 10px 25px rgba(0,0,0,0.25);
  overflow:hidden;
}

/* BODY */
.package-popup-body{
  padding:20px;
}

/* HEADER ROW */
.package-table-header{
  display:grid;
  grid-template-columns:50px 2fr 1fr 1fr 1fr;
  align-items:center;
  background:#8B1E3F;
  color:#fff;
  padding:10px;
  font-weight:600;
  font-size:13px;
  border-radius:6px 6px 0 0;
}

/* DATA ROW */
.package-table-row{
  display:grid;
  grid-template-columns:50px 2fr 1fr 1fr 1fr;
  align-items:center;
  padding:10px;
  border:1px solid #ddd;
  border-top:none;
  gap:10px;
}

/* INPUT STYLE */
.pkg-input{
  width:100%;
  height:34px;
  border:1px solid #ccc;
  border-radius:6px;
  padding:4px 8px;
  font-size:13px;
}

/* ===== MOBILE RESPONSIVE ===== */
@media (max-width:768px){

  .package-table-header{
    display:none;
  }

  .package-table-row{
    grid-template-columns:1fr;
    border:1px solid #ddd;
    border-radius:6px;
    margin-bottom:10px;
  }

  .package-table-row div{
    display:flex;
    flex-direction:column;
  }

}
  .step5-footer {
  position: relative;
}

.center-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
`}</style>
    </Layout>
  );
};

export default BookingDocketDetailsDesign;
